<template>
    <div class>
        <div class="pay-now-block">
            <div class="container">
                <button
                    @click="printPage"
                    class="btn btn_primary text_white chat_btn bg_primary_blue"
                    v-if="thankyoupayment || paymentAlradyCompleted"
                >
                    Print
                </button>
            </div>
        </div>
        <div class="print-reciept" ref="printArea">
            <div class="top_header">
                <div class="container">
                    <div class="header_main">
                        <div class="left_part">
                            <a href="/admin/production/orders" class=""
                                ><img
                                    src="/maincss/images/orderproofreview_logo.svg"
                                    alt=""
                                    class="opr_logo_img"
                            /></a>
                            <h1
                                v-if="thankyoupayment || paymentAlradyCompleted"
                                class="page-heading"
                            >
                                Order #{{
                                    order_data && order_data.unique_order_id
                                        ? order_data.unique_order_id
                                        : ""
                                }}
                            </h1>
                            <h1 v-else class="page-heading">Checkout</h1>
                        </div>
                    </div>
                </div>
            </div>

            <section class="shipping_payment_detail shipping_payment pt-0">
                <div class="container">
                    <div v-if="paymentAlradyCompleted || thankyoupayment">
                        <div class="success-msg">
                            <h4 class="thank-you-msg">Thank you!</h4>
                            <p>
                                Your payment has been successfully processed.
                                Your order is now being processed.

                                <!-- you will get order id here -->
                            </p>
                        </div>
                    </div>
                    <div
                        class="row shipping-box white_box p_10 ml-0 mr-0 mt_20"
                    >
                        <div class="col-md-4">
                            <div class="delevery_block mt_10">
                                <h3>Customer Info</h3>
                                <span v-if="customer_data.fullname">
                                    {{ customer_data.fullname }}<br />
                                </span>
                                <span v-if="customer_data.email">
                                    {{ customer_data.email }}<br />
                                </span>
                                <span v-if="customer_data.phone">
                                    {{ customer_data.phone }}<br />
                                </span>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="delevery_block mt_10">
                                <h3>Billing Address</h3>

                                <span v-if="billing_address_data.address_label">
                                    <b>Company Name:</b>
                                    {{ billing_address_data.address_label
                                    }}<br />
                                </span>
                                <span
                                    v-if="
                                        billing_address_data.first_name ||
                                        billing_address_data.last_name
                                    "
                                >
                                    <b>Recipient Name:</b>
                                    {{
                                        billing_address_data.first_name +
                                        " " +
                                        billing_address_data.last_name
                                    }}<br />
                                </span>
                                <span v-if="billing_address_data.address1">
                                    {{ billing_address_data.address1 }}<br />
                                </span>
                                <span v-if="billing_address_data.address2">
                                    {{ billing_address_data.address2 }}<br />
                                </span>

                                <span
                                    v-if="
                                        billing_address_data.city ||
                                        billing_address_data.state ||
                                        billing_address_data.pincode
                                    "
                                >
                                    {{
                                        [
                                            billing_address_data.city,
                                            billing_address_data.state
                                        ]
                                            .filter(Boolean)
                                            .join(", ") +
                                        (billing_address_data.pincode
                                            ? " " + billing_address_data.pincode
                                            : "")
                                    }}
                                </span>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="delevery_block mt_10">
                                <h3>Shipping Address</h3>

                                <span
                                    v-if="
                                        shipping_address_data.shippingaddress_label
                                    "
                                >
                                    <b>Company Name:</b>
                                    {{
                                        shipping_address_data.shippingaddress_label
                                    }}<br />
                                </span>
                                <span
                                    v-if="
                                        shipping_address_data.first_name ||
                                        shipping_address_data.last_name
                                    "
                                >
                                    <b>Recipient Name:</b>
                                    {{
                                        shipping_address_data.first_name +
                                        " " +
                                        shipping_address_data.last_name
                                    }}<br />
                                </span>
                                <span v-if="shipping_address_data.address1">
                                    {{ shipping_address_data.address1 }}<br />
                                </span>
                                <span v-if="shipping_address_data.address2">
                                    {{ shipping_address_data.address2 }}<br />
                                </span>

                                <span
                                    v-if="
                                        shipping_address_data.city ||
                                        shipping_address_data.state ||
                                        shipping_address_data.pincode
                                    "
                                >
                                    {{
                                        [
                                            shipping_address_data.city,
                                            shipping_address_data.state
                                        ]
                                            .filter(Boolean)
                                            .join(", ") +
                                        (shipping_address_data.pincode
                                            ? " " +
                                              shipping_address_data.pincode
                                            : "")
                                    }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <!-- Post-payment order details (tabbed, parity with frontend Order_detail.vue) -->
                    <div
                        v-if="(paymentAlradyCompleted || thankyoupayment) && processedOrderData"
                        class="order-tabs-wrapper mb-1 mt_20"
                    >
                        <div class="tabs-block">
                            <ul>
                                <li class="nav-item">
                                    <a
                                        class="nav-link"
                                        :class="{ active: activeTab === 'items' }"
                                        href="javascript:void(0)"
                                        @click="activeTab = 'items'"
                                    >
                                        Order Items
                                    </a>
                                </li>
                                <li class="nav-item" v-if="hasSplitShipments">
                                    <a
                                        class="nav-link"
                                        :class="{ active: activeTab === 'byAddress' }"
                                        href="javascript:void(0)"
                                        @click="activeTab = 'byAddress'"
                                    >
                                        Items by Address
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <OrderDetails
                        v-if="
                            (paymentAlradyCompleted || thankyoupayment) &&
                            processedOrderData &&
                            activeTab === 'items'
                        "
                        :order_data="processedOrderData"
                        :total_non_standard_colors="total_non_standard_colors"
                        :thankyoupayment="thankyoupayment"
                        :paymentAlradyCompleted="paymentAlradyCompleted"
                        :paymentId="paymentId"
                    />

                    <OrderItemsByAddress
                        v-if="
                            (paymentAlradyCompleted || thankyoupayment) &&
                            processedOrderData &&
                            activeTab === 'byAddress' &&
                            hasSplitShipments
                        "
                        :addresses="addressesWithSplits"
                        :items-by-address="itemsByAddress"
                        :order-detail="processedOrderData"
                        :cost-summary="costSummaryByAddress"
                        :format-price="icPriceFormat"
                    />

                    <div class="row mt_20 pending_payment_page">
                        <div class="col-md-12 col-lg-6 mobile_pr_15">
                            <div
                                class="white_box py_52 px_50 shipping_fl_left payment-shipment-mg card-shipping"
                                v-if="showCartSummaryComponent"
                            >
                                <form
                                    method="post"
                                    @submit.prevent="proceedToPay"
                                    data-vv-scope="paymentform"
                                    class="f_fl_left"
                                >
                                    <div class="payment_method">
                                        <h1 class="font_size_28 payment_title">
                                            Payment method
                                        </h1>
                                        <div class="payment-method-main">
                                            <!-- Pay via Credit Card - Only for logged in customers -->
                                            <div
                                                class="payment_method mt_16 new_payment_credit_card_block"
                                            >
                                                <div
                                                    class="shipping-options-section new_payment_method_radio_button"
                                                >
                                                    <div
                                                        class="shipping-options-radio-group"
                                                    >
                                                        <label
                                                            for="payviacreditcard"
                                                            class="shipping-option-label"
                                                        >
                                                            <input
                                                                type="radio"
                                                                id="payviacreditcard"
                                                                :value="false"
                                                                v-model="
                                                                    is_pay_way_terms
                                                                "
                                                                name="radio-group"
                                                                @click="
                                                                    selectPaymentOption(
                                                                        'pay_via_credit_card'
                                                                    )
                                                                "
                                                            />
                                                            <span
                                                                class="radio-title"
                                                                >Pay via Credit
                                                                Card</span
                                                            >
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="coupon ml_24"
                                                v-if="
                                                    total_orders > 0 &&
                                                    term_payment_info.creditlimit >
                                                        1 &&
                                                    parseFloat(
                                                        term_payment_info.unbilled_orders ||
                                                            0
                                                    ) <
                                                        parseFloat(
                                                            term_payment_info.creditlimit ||
                                                                0
                                                        )
                                                "
                                            >
                                                <div
                                                    class="row align-items-end"
                                                >
                                                    <div
                                                        class="col-md-12 col-lg-12 col-xlg-9"
                                                    >
                                                        <div id="accordion">
                                                            <div
                                                                class="form-check p-0 pay-terms"
                                                            >
                                                                <div
                                                                    class="pay card-pay pb-0 d-flex mt_0 border-top-0"
                                                                >
                                                                    <!-- <div class="label-popup" data-toggle="collapse" data-target="#payWayTerms" aria-expanded="true" aria-controls="payWayTerms"> -->
                                                                    <div
                                                                        class="shipping-options-section new_payment_method_radio_button"
                                                                    >
                                                                        <div
                                                                            class="shipping-options-radio-group"
                                                                        >
                                                                            <label
                                                                                for="flexCheck"
                                                                                class="shipping-option-label"
                                                                            >
                                                                                <input
                                                                                    class="form-check-input"
                                                                                    type="radio"
                                                                                    :value="
                                                                                        true
                                                                                    "
                                                                                    v-model="
                                                                                        is_pay_way_terms
                                                                                    "
                                                                                    id="flexCheck"
                                                                                    name="radio-group"
                                                                                    @click="
                                                                                        selectPaymentOption(
                                                                                            'pay_way_terms'
                                                                                        )
                                                                                    "
                                                                                />
                                                                                <span
                                                                                    class="radio-title"
                                                                                    >Pay
                                                                                    via
                                                                                    Terms</span
                                                                                >
                                                                                <img
                                                                                    src="/maincss/images/info.svg"
                                                                                    alt=" "
                                                                                />
                                                                            </label>
                                                                            <!-- <span class="term-amount" v-if="
                                                    termPaymentInfo.creditlimit
                                                ">{{
                                                    icPriceFormat(
                                                    termPaymentInfo.creditlimit
                                                    )
                                                    }}</span>
                                                <span class="term-amount" v-else>{{
                                                    icPriceFormat(0)
                                                    }}</span> -->
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Pay via Credit Card Section - Only visible when Pay via Credit Card radio button is selected -->
                                        <div
                                            v-if="!is_pay_way_terms"
                                            class="pay_via_credit_card_section"
                                        >
                                            <div class="payment_cards_info">
                                                <!-- Show message when no valid cards are available -->
                                                <div
                                                    v-if="
                                                        !hasValidPaymentMethods
                                                    "
                                                    class="no-card-message"
                                                    style="
                                                        padding: 20px;
                                                        text-align: center;
                                                        color: #666;
                                                    "
                                                >
                                                    <p
                                                        style="
                                                            margin: 0;
                                                            font-size: 16px;
                                                        "
                                                    >
                                                        No card available.
                                                        Please add new card.
                                                    </p>
                                                </div>

                                                <div
                                                    class="card_item mt_0 border-top-0"
                                                    v-for="(
                                                        payment_methods, indx
                                                    ) in all_payment_methods"
                                                    :key="indx"
                                                    :style="
                                                        payment_methods.expired_time <
                                                        new Date()
                                                            ? 'display:none !important'
                                                            : ''
                                                    "
                                                >
                                                    <div
                                                        class="card_main_wrapper"
                                                    >
                                                        <div
                                                            class="cards_item_main"
                                                        >
                                                            <div
                                                                class="card_check_item"
                                                            >
                                                                <input
                                                                    type="radio"
                                                                    :value="
                                                                        payment_methods.customerPaymentProfileId
                                                                    "
                                                                    :id="
                                                                        payment_methods.customerPaymentProfileId
                                                                    "
                                                                    name="card-radio-group"
                                                                    :checked="
                                                                        payment_methods.customerPaymentProfileId ==
                                                                        selected_card.customerPaymentProfileId
                                                                    "
                                                                    @change="
                                                                        selectPaymentMethod(
                                                                            payment_methods.customerPaymentProfileId,
                                                                            payment_methods.expired_time,
                                                                            $event
                                                                        )
                                                                    "
                                                                />
                                                                <!-- v-model="order_data.is_credit_card" -->
                                                            </div>
                                                            <div
                                                                class="card_info"
                                                            >
                                                                <div
                                                                    class="mr_6 cards_img"
                                                                    v-if="
                                                                        payment_methods
                                                                            .payment
                                                                            .creditCard
                                                                            .cardType ==
                                                                        'Visa'
                                                                    "
                                                                >
                                                                    <img
                                                                        :src="
                                                                            base_url +
                                                                            '/maincss/images/add_visa_logo.png'
                                                                        "
                                                                        alt=" "
                                                                    />
                                                                </div>
                                                                <div
                                                                    class="mr_6 cards_img"
                                                                    v-else-if="
                                                                        payment_methods
                                                                            .payment
                                                                            .creditCard
                                                                            .cardType ==
                                                                        'MasterCard'
                                                                    "
                                                                >
                                                                    <img
                                                                        :src="
                                                                            base_url +
                                                                            '/maincss/images/master_card_logo.png'
                                                                        "
                                                                        alt=" "
                                                                    />
                                                                </div>
                                                                <div
                                                                    class="mr_6 cards_img"
                                                                    v-else-if="
                                                                        payment_methods
                                                                            .payment
                                                                            .creditCard
                                                                            .cardType ==
                                                                        'JCB'
                                                                    "
                                                                >
                                                                    <img
                                                                        :src="
                                                                            base_url +
                                                                            '/maincss/images/jcb_logo.svg'
                                                                        "
                                                                        alt=" "
                                                                    />
                                                                </div>
                                                                <div
                                                                    class="mr_6 cards_img"
                                                                    v-else-if="
                                                                        payment_methods
                                                                            .payment
                                                                            .creditCard
                                                                            .cardType ==
                                                                        'Discover'
                                                                    "
                                                                >
                                                                    <img
                                                                        :src="
                                                                            base_url +
                                                                            '/maincss/images/discover_logo.svg'
                                                                        "
                                                                        alt=" "
                                                                    />
                                                                </div>
                                                                <div
                                                                    class="mr_6 cards_img"
                                                                    v-else-if="
                                                                        payment_methods
                                                                            .payment
                                                                            .creditCard
                                                                            .cardType ==
                                                                        'AmericanExpress'
                                                                    "
                                                                >
                                                                    <img
                                                                        :src="
                                                                            base_url +
                                                                            '/maincss/images/american_express_logo.svg'
                                                                        "
                                                                        alt=" "
                                                                    />
                                                                </div>
                                                                <div
                                                                    class="mr_6 cards_img"
                                                                    v-else
                                                                >
                                                                    <img
                                                                        :src="
                                                                            base_url +
                                                                            '/maincss/images/unknown_card_logo.svg'
                                                                        "
                                                                        alt=" "
                                                                    />
                                                                </div>
                                                                <label
                                                                    :for="
                                                                        payment_methods.customerPaymentProfileId
                                                                    "
                                                                    class="m-0"
                                                                >
                                                                    **** ****
                                                                    ****
                                                                    <span
                                                                        class="cc_opa"
                                                                    >
                                                                        {{
                                                                            payment_methods
                                                                                .payment
                                                                                .creditCard
                                                                                .cardNumber
                                                                                ? payment_methods.payment.creditCard.cardNumber.substr(
                                                                                      -4
                                                                                  )
                                                                                : ""
                                                                        }}
                                                                    </span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div class="right_item">
                                                            <p>
                                                                {{
                                                                    payment_methods.payment &&
                                                                    payment_methods
                                                                        .payment
                                                                        .creditCard &&
                                                                    payment_methods
                                                                        .payment
                                                                        .creditCard
                                                                        .expirationDate
                                                                        ? (() => {
                                                                              const expDate =
                                                                                  payment_methods
                                                                                      .payment
                                                                                      .creditCard
                                                                                      .expirationDate;
                                                                              // Parse expiration date (format: YYYY-MM)
                                                                              const parts =
                                                                                  expDate.split(
                                                                                      "-"
                                                                                  );
                                                                              if (
                                                                                  parts.length >=
                                                                                  2
                                                                              ) {
                                                                                  const year =
                                                                                      parts[0].substr(
                                                                                          -2
                                                                                      ); // Last 2 digits of year
                                                                                  const month =
                                                                                      parts[1].trim(); // Month
                                                                                  return (
                                                                                      month +
                                                                                      "/" +
                                                                                      year
                                                                                  );
                                                                              }
                                                                              return "09/2025"; // Fallback
                                                                          })()
                                                                        : "09/2025"
                                                                }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-if="hasValidPaymentMethods">
                                                <div
                                                    class="two_input_one_row payment_choice_main"
                                                >
                                                    <div
                                                        class="form-group card-no"
                                                    >
                                                        <label
                                                            >Card number</label
                                                        >
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            id="Card Number"
                                                            name="CardNumber"
                                                            placeholder="Enter Card Number"
                                                            :value="
                                                                selected_card.cardnumber
                                                                    ? '#### #### #### ' +
                                                                      selected_card.cardnumber
                                                                    : undefined
                                                            "
                                                            v-validate="
                                                                !is_pay_way_terms
                                                                    ? 'required|min:16|max:19'
                                                                    : ''
                                                            "
                                                            data-vv-as="Card Number"
                                                            disabled
                                                        />

                                                        <span
                                                            class="highlight"
                                                        ></span>
                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                errors.has(
                                                                    'paymentform.CardNumber'
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                errors.first(
                                                                    "paymentform.CardNumber"
                                                                )
                                                            }}
                                                        </small>
                                                    </div>

                                                    <div
                                                        class="form-group position-relative expiration"
                                                    >
                                                        <label
                                                            class="select_option_label"
                                                            >Month</label
                                                        >
                                                        <select
                                                            class="form-control bg-transparent"
                                                            v-model="
                                                                selected_card.cardexpiremonth
                                                            "
                                                            name="Expiration Month"
                                                            v-validate="
                                                                'required'
                                                            "
                                                            data-vv-as="Expiration Month"
                                                            disabled
                                                        >
                                                            <option
                                                                v-for="n in 12"
                                                                :value="
                                                                    10 > n
                                                                        ? '0' +
                                                                          n
                                                                        : n
                                                                "
                                                                :key="n"
                                                                :disabled="
                                                                    n <
                                                                        new Date().getMonth() +
                                                                            1 &&
                                                                    changedYear <=
                                                                        currentYear
                                                                "
                                                            >
                                                                {{
                                                                    10 > n
                                                                        ? "0" +
                                                                          n
                                                                        : n
                                                                }}
                                                            </option>
                                                        </select>
                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                errors.has(
                                                                    'paymentform.Expiration Month'
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                errors.first(
                                                                    "paymentform.Expiration Month"
                                                                )
                                                            }}
                                                        </small>
                                                    </div>
                                                    <div
                                                        class="form-group position-relative expiration"
                                                    >
                                                        <label
                                                            class="select_option_label"
                                                            >Year</label
                                                        >
                                                        <select
                                                            class="form-control bg-transparent"
                                                            v-model="
                                                                selected_card.cardexpireyear
                                                            "
                                                            name="Expiration Year"
                                                            v-validate="
                                                                'required'
                                                            "
                                                            data-vv-as="Expiration Year"
                                                            disabled
                                                            @change="
                                                                changeCardYear(
                                                                    $event,
                                                                    selected_card
                                                                )
                                                            "
                                                        >
                                                            <option
                                                                v-for="year in years"
                                                                :key="year"
                                                                :value="
                                                                    year
                                                                        ? year
                                                                              .toString()
                                                                              .substr(
                                                                                  -2
                                                                              )
                                                                        : ''
                                                                "
                                                            >
                                                                {{ year }}
                                                            </option>
                                                        </select>
                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                errors.has(
                                                                    'paymentform.Expiration Year'
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                errors.first(
                                                                    "paymentform.Expiration Year"
                                                                )
                                                            }}
                                                        </small>
                                                    </div>
                                                    <div
                                                        class="form-group securit_code"
                                                    >
                                                        <label
                                                            >Security code
                                                            <div
                                                                class="alert-icon pb-2"
                                                                data-toggle="tooltip"
                                                                data-placement="bottom"
                                                                v-tooltip="
                                                                    'Credit Card Security Code'
                                                                "
                                                            >
                                                                <img
                                                                    src="/maincss/images/info.svg"
                                                                    alt=" "
                                                                /></div
                                                        ></label>
                                                        <input
                                                            maxlength="3"
                                                            type="password"
                                                            class="form-control"
                                                            id="Security Code"
                                                            placeholder="Enter Code "
                                                            name="Security Code"
                                                            v-model="
                                                                selected_card.cardsecuritycode
                                                            "
                                                            v-validate="
                                                                !is_pay_way_terms
                                                                    ? 'required|numeric|length:3'
                                                                    : ''
                                                            "
                                                            @input="
                                                                cardSecurityFormat
                                                            "
                                                            :disabled="
                                                                !selected_card.customerPaymentProfileId
                                                            "
                                                        />

                                                        <span
                                                            class="highlight"
                                                        ></span>
                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                errors.has(
                                                                    'paymentform.Security Code'
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                errors.first(
                                                                    "paymentform.Security Code"
                                                                )
                                                            }}
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="card-pay radio_butoons_headding add_new_payment_card d-flex mt_0 border-top-0 border-bottom info-toggle"
                                            >
                                                <a
                                                    href="javascript:void(0);"
                                                    class="payment_box d-flex justify-content-center align-items-center flex-column text-center h-100"
                                                    data-keyboard="false"
                                                    data-toggle="modal"
                                                    data-target="#add_payment_method_model"
                                                    data-dismiss="modal"
                                                >
                                                    <a
                                                        ><b>+ Add New Card </b>
                                                    </a>
                                                </a>
                                                <!-- <div class="alert-icon pb-2 info-toggle-inside">
                                                    <img src="/maincss/images/information.svg" alt="Info"
                                                        data-toggle="tooltip" data-placement="bottom" v-tooltip="
                                                            'Card information will be securely stored on Authorize.net.'
                                                        " />
                                                </div> -->

                                                <img
                                                    src="/maincss/images/cards.png"
                                                    alt=" "
                                                    class="ml-auto mr_6 cards_img"
                                                />
                                            </div>
                                        </div>

                                        <div
                                            v-if="
                                                credit_limit > 0 &&
                                                parseFloat(
                                                    term_payment_info.unbilled_orders ||
                                                        0
                                                ) <
                                                    parseFloat(
                                                        term_payment_info.creditlimit ||
                                                            0
                                                    )
                                            "
                                            class="radio_butoons_headding pay_via_terms_box d-flex mt_16 border-top-0 border-bottom"
                                        >
                                            <div class="position-relative">
                                                <p class="m-0">
                                                    <input
                                                        type="radio"
                                                        :value="true"
                                                        id="test2"
                                                        v-model="
                                                            is_pay_way_terms
                                                        "
                                                        name="radio-group"
                                                        @click="
                                                            selectPaymentOption(
                                                                'pay_way_terms'
                                                            )
                                                        "
                                                    />
                                                    <label
                                                        for="test2"
                                                        class="m-0"
                                                    >
                                                        <span class="cc_opa"
                                                            >Pay via terms</span
                                                        >
                                                    </label>
                                                </p>
                                                <div
                                                    class="alert-icon pb-2"
                                                    data-toggle="tooltip"
                                                    data-placement="bottom"
                                                    v-tooltip="'Pay via terms'"
                                                >
                                                    <img
                                                        src="/maincss/images/information.svg"
                                                        alt=" "
                                                    />
                                                </div>
                                            </div>

                                            <span
                                                class="text-right ml-auto mr_6 cards_img font-weight-bold heading5"
                                                >${{ credit_limit }}</span
                                            >
                                        </div>
                                    </div>

                                    <div
                                        id="payWayTerms"
                                        class="collapse"
                                        :class="{
                                            show:
                                                is_pay_way_terms == 1 ||
                                                is_pay_way_terms == true
                                        }"
                                        aria-labelledby="headingOne"
                                        data-parent="#accordion"
                                    >
                                        <div class="pay-box">
                                            <div class="balance-box">
                                                <h5>Credit Limit:</h5>
                                                <h3
                                                    v-if="
                                                        term_payment_info.creditlimit
                                                    "
                                                >
                                                    {{
                                                        icPriceFormat(
                                                            term_payment_info.creditlimit
                                                        )
                                                    }}
                                                </h3>
                                                <h3 v-else>
                                                    {{ icPriceFormat(0) }}
                                                </h3>
                                            </div>

                                            <div class="balance-block">
                                                <div class="odered-balance">
                                                    <h5>Unpaid Invoices:</h5>
                                                    <h3
                                                        class="text-danger"
                                                        v-if="
                                                            term_payment_info.unpaid_invoices
                                                        "
                                                    >
                                                        {{
                                                            icPriceFormat(
                                                                term_payment_info.unpaid_invoices
                                                            )
                                                        }}
                                                    </h3>
                                                    <h3
                                                        class="text-danger"
                                                        v-else
                                                    >
                                                        {{ icPriceFormat(0) }}
                                                    </h3>
                                                </div>
                                                <div class="odered-balance">
                                                    <h5>Overdue balance:</h5>
                                                    <h3
                                                        :class="{
                                                            'text-danger':
                                                                term_payment_info.overdue_balance <
                                                                0
                                                        }"
                                                        v-if="
                                                            term_payment_info.overdue_balance
                                                        "
                                                    >
                                                        {{
                                                            icPriceFormat(
                                                                term_payment_info.overdue_balance
                                                            )
                                                        }}
                                                    </h3>
                                                    <h3 v-else>
                                                        {{ icPriceFormat(0) }}
                                                    </h3>
                                                </div>
                                                <div class="odered-balance">
                                                    <h5>Unbilled Orders:</h5>
                                                    <h3
                                                        class="text-danger"
                                                        v-if="
                                                            term_payment_info.unbilled_orders
                                                        "
                                                    >
                                                        {{
                                                            icPriceFormat(
                                                                term_payment_info.unbilled_orders
                                                            )
                                                        }}
                                                    </h3>
                                                    <h3
                                                        class="text-danger"
                                                        v-else
                                                    >
                                                        {{ icPriceFormat(0) }}
                                                    </h3>
                                                </div>
                                                <div class="odered-balance">
                                                    <h5>Unapplied Credits:</h5>
                                                    <h3
                                                        :class="{
                                                            'text-danger':
                                                                term_payment_info.unapplied_credits <
                                                                0
                                                        }"
                                                        v-if="
                                                            term_payment_info.unapplied_credits
                                                        "
                                                    >
                                                        {{
                                                            icPriceFormat(
                                                                term_payment_info.unapplied_credits
                                                            )
                                                        }}
                                                    </h3>
                                                    <h3 v-else>
                                                        {{ icPriceFormat(0) }}
                                                    </h3>
                                                </div>
                                                <div class="odered-balance">
                                                    <h5>
                                                        Available on Account:
                                                    </h5>
                                                    <h3
                                                        :class="{
                                                            'text-danger':
                                                                term_payment_info.avalaible_on_account <
                                                                0
                                                        }"
                                                        v-if="
                                                            term_payment_info.avalaible_on_account
                                                        "
                                                    >
                                                        {{
                                                            icPriceFormat(
                                                                term_payment_info.avalaible_on_account
                                                            )
                                                        }}
                                                    </h3>
                                                    <h3 v-else>
                                                        {{ icPriceFormat(0) }}
                                                    </h3>
                                                </div>
                                                <div class="odered-balance">
                                                    <h5>Current Order:</h5>
                                                    <h3 class="text-danger">
                                                        {{
                                                            icPriceFormat(
                                                                grand_total_price
                                                            )
                                                        }}
                                                    </h3>
                                                </div>
                                            </div>

                                            <div class="balance-box">
                                                <h5>Available Credit:</h5>
                                                <h3
                                                    v-if="
                                                        term_payment_info.avalaible_on_account
                                                    "
                                                >
                                                    {{
                                                        icPriceFormat(
                                                            term_payment_info.avalaible_on_account -
                                                                grand_total_price
                                                        )
                                                    }}
                                                </h3>
                                                <h3 v-else>
                                                    {{ icPriceFormat(0) }}
                                                </h3>
                                            </div>

                                            <!-- Remaining Payment Card Section - Shows when card is selected from insufficient popup -->
                                            <div
                                                v-if="
                                                    is_pay_way_terms &&
                                                    is_remaining_pay_card
                                                "
                                                class="remaining-payment-card-section mt_20"
                                            >
                                                <h5 class="mb_16">
                                                    Remaining Payment Card:
                                                </h5>
                                                <div class="payment_cards_info">
                                                    <div
                                                        class="card_item mt_0 border-top-0"
                                                    >
                                                        <div
                                                            class="card_main_wrapper"
                                                        >
                                                            <div
                                                                class="cards_item_main"
                                                            >
                                                                <div
                                                                    class="card_info"
                                                                >
                                                                    <div
                                                                        class="mr_6 cards_img"
                                                                        v-if="
                                                                            card_info2 &&
                                                                            card_info2.cardtype ==
                                                                                'Visa'
                                                                        "
                                                                    >
                                                                        <img
                                                                            :src="
                                                                                base_url +
                                                                                '/maincss/images/add_visa_logo.png'
                                                                            "
                                                                            alt=" "
                                                                        />
                                                                    </div>

                                                                    <div
                                                                        class="mr_6 cards_img"
                                                                        v-else-if="
                                                                            card_info2 &&
                                                                            card_info2.cardtype ==
                                                                                'MasterCard'
                                                                        "
                                                                    >
                                                                        <img
                                                                            :src="
                                                                                base_url +
                                                                                '/maincss/images/master_card_logo.png'
                                                                            "
                                                                            alt=" "
                                                                        />
                                                                    </div>

                                                                    <div
                                                                        class="mr_6 cards_img"
                                                                        v-else-if="
                                                                            card_info2 &&
                                                                            card_info2.cardtype ==
                                                                                'JCB'
                                                                        "
                                                                    >
                                                                        <img
                                                                            :src="
                                                                                base_url +
                                                                                '/maincss/images/jcb_logo.svg'
                                                                            "
                                                                            alt=" "
                                                                        />
                                                                    </div>

                                                                    <div
                                                                        class="mr_6 cards_img"
                                                                        v-else-if="
                                                                            card_info2 &&
                                                                            card_info2.cardtype ==
                                                                                'Discover'
                                                                        "
                                                                    >
                                                                        <img
                                                                            :src="
                                                                                base_url +
                                                                                '/maincss/images/discover_logo.svg'
                                                                            "
                                                                            alt=" "
                                                                        />
                                                                    </div>

                                                                    <div
                                                                        class="mr_6 cards_img"
                                                                        v-else-if="
                                                                            card_info2 &&
                                                                            card_info2.cardtype ==
                                                                                'AmericanExpress'
                                                                        "
                                                                    >
                                                                        <img
                                                                            :src="
                                                                                base_url +
                                                                                '/maincss/images/american_express_logo.svg'
                                                                            "
                                                                            alt=" "
                                                                        />
                                                                    </div>

                                                                    <label
                                                                        class="m-0"
                                                                    >
                                                                        ****
                                                                        ****
                                                                        ****
                                                                        <span
                                                                            class="cc_opa"
                                                                        >
                                                                            {{
                                                                                card_info2 &&
                                                                                card_info2.cardnumber
                                                                                    ? card_info2.cardnumber
                                                                                    : ""
                                                                            }}
                                                                        </span>
                                                                    </label>
                                                                    <span
                                                                        v-if="
                                                                            card_info2 &&
                                                                            card_info2.cardexpiremonth &&
                                                                            card_info2.cardexpireyear
                                                                                ? card_info2.cardexpiremonth +
                                                                                  '/' +
                                                                                  card_info2.cardexpireyear
                                                                                : ''
                                                                        "
                                                                        class="card_expire_date"
                                                                    >
                                                                        {{
                                                                            card_info2 &&
                                                                            card_info2.cardexpiremonth &&
                                                                            card_info2.cardexpireyear
                                                                                ? card_info2.cardexpiremonth +
                                                                                  "/" +
                                                                                  card_info2.cardexpireyear
                                                                                : ""
                                                                        }}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- TERM PAYMENT -->

                                    <div class="coupon mt_20">
                                        <div class="row align-items-end">
                                            <div
                                                class="col-md-12 col-lg-12 col-xlg-9"
                                            >
                                                <p
                                                    class="mb-0 font_size_14 new_comm_field_title"
                                                >
                                                    PO number
                                                    <span
                                                        v-if="!is_pay_way_terms"
                                                        >( Optional )</span
                                                    >
                                                </p>
                                                <div class="d-flex coupon">
                                                    <div
                                                        class="form-group mt-1 ml-0 w-100"
                                                    >
                                                        <input
                                                            type="text"
                                                            placeholder="Enter PO number"
                                                            class="form-control"
                                                            v-model="po_number"
                                                            name="PO Number"
                                                            v-validate="
                                                                is_pay_way_terms
                                                                    ? 'required'
                                                                    : ''
                                                            "
                                                            data-vv-as="PO Number"
                                                        />
                                                        <span
                                                            class="highlight"
                                                        ></span>
                                                        <small
                                                            class="form-text text-error text-left"
                                                            v-show="
                                                                errors.has(
                                                                    'paymentform.PO Number'
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                errors.first(
                                                                    "paymentform.PO Number"
                                                                )
                                                            }}
                                                        </small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="mt_36">
                                        <button
                                            v-if="is_pay_way_terms"
                                            @click="payViaTerms"
                                            type="button"
                                            class="btn btn_orange bg_primary_orange text_white d-block mt_36 py_22"
                                            style="width: 100%; max-width: 100%"
                                        >
                                            Make Payment
                                        </button>
                                        <button
                                            v-else
                                            type="submit"
                                            class="btn btn_orange bg_primary_orange text_white d-block mt_36 py_22"
                                            style="width: 100%; max-width: 100%"
                                        >
                                            Make Payment
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <!-- Cart Summary with Breakdowns -->
                        <div
                            v-if="!paymentAlradyCompleted && !thankyoupayment"
                            class="col-md-12 col-lg-6 mobile_pl_15"
                        >
                            <div
                                class="cart_summary h-100 white_box py_52 px_52 cart-shipping-address"
                            >
                                <h4
                                    class="font_size_30 d-flex mb_28 cart_summary_heading_h4"
                                >
                                    Cart Summary
                                </h4>
                                <div class="cart_sum_overflow-y overflow_pop_y">
                                    <div
                                        class="cart_summary_custome_div"
                                        v-for="(item, key) in order_data &&
                                        order_data.items
                                            ? order_data.items
                                            : []"
                                        :key="item.id + key"
                                    >
                                        <div
                                            class="cart_items media cart_image"
                                        >
                                            <DisplayProductImage
                                                :whateverActivatesThisLink="
                                                    false
                                                "
                                                :product="item"
                                                :designImage="item.design_image"
                                                :color="item.color_id"
                                                :classValue="'mr-auto'"
                                            />
                                            <div class="media-body">
                                                <div
                                                    v-if="
                                                        item.OrderBuild &&
                                                        item.front_art_url
                                                    "
                                                >
                                                    Build:
                                                    {{ item.OrderBuild.name }}
                                                </div>
                                                <h4
                                                    class="font_size_20 d-md-flex mb-0 h4_dropdown_box_custom"
                                                >
                                                    <div>{{ item.name }}</div>
                                                    <div
                                                        class="d-flex justify-content-end align-items-flex-start new_span_price"
                                                    >
                                                        <span
                                                            class="font_size_22 ml-auto pr-2"
                                                        >
                                                            {{
                                                                item.item_sub_total
                                                                    ? icPriceFormat(
                                                                          parseFloat(
                                                                              item.item_sub_total ||
                                                                                  0
                                                                          ) -
                                                                              parseFloat(
                                                                                  item.total_discount ||
                                                                                      0
                                                                              )
                                                                      )
                                                                    : icPriceFormat(
                                                                          parseFloat(
                                                                              item.total_price ||
                                                                                  0
                                                                          ) -
                                                                              parseFloat(
                                                                                  item.total_discount ||
                                                                                      0
                                                                              )
                                                                      )
                                                            }}
                                                        </span>
                                                    </div>
                                                </h4>
                                                <p
                                                    class="font_size_16 mt_8 mb-0 text_light_grey"
                                                >
                                                    {{
                                                        item.Category
                                                            ? item.Category
                                                                  .title
                                                            : ""
                                                    }}
                                                </p>
                                                <p
                                                    class="font_size_16 mb-0 text_light_grey"
                                                >
                                                    {{ showSizes(item.sizes) }}
                                                </p>
                                                <p
                                                    v-if="
                                                        getEstimatedShippingDate(
                                                            item
                                                        )
                                                    "
                                                    class="font_size_14 mb-0 text_light_grey"
                                                    style="margin-top: 4px"
                                                >
                                                    Est. Ship Date:
                                                    {{
                                                        formatEstimatedShippingDate(
                                                            getEstimatedShippingDate(
                                                                item
                                                            )
                                                        )
                                                    }}
                                                </p>
                                                <ul
                                                    v-if="
                                                        item.decoration_colors &&
                                                        item.decoration_colors
                                                            .length > 0
                                                    "
                                                    class="standard_colors"
                                                >
                                                    <li
                                                        v-for="(
                                                            color, index
                                                        ) in item.decoration_colors"
                                                        :style="
                                                            'background-color:' +
                                                            color.hex +
                                                            ';'
                                                        "
                                                        :key="index"
                                                        v-tooltip="{
                                                            content: color.name
                                                                ? `${color.name}<br/>${color.hex}`
                                                                : color.hex,
                                                            html: true
                                                        }"
                                                    ></li>
                                                </ul>
                                                <small
                                                    v-if="item.t_shirt_24_hour"
                                                    >24 Hours T-Shirt</small
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="mt_30"></div>

                                <div v-show="!cartNotEmpty">
                                    <p class="font_size_16 mt_8 mb-0">
                                        No item added yet.
                                    </p>
                                </div>

                                <div class="order-breakdown-section">
                                    <div class="breakdown-item">
                                        <span class="breakdown-label"
                                            >Sub Total</span
                                        >
                                        <span class="breakdown-value">
                                            {{
                                                cartNotEmpty &&
                                                order_data.subtotal
                                                    ? icPriceFormat(
                                                          order_data.subtotal
                                                      )
                                                    : "$0.00"
                                            }}
                                        </span>
                                    </div>

                                    <div
                                        class="breakdown-item"
                                        v-if="getPackagingTotal() > 0"
                                    >
                                        <PendingPaymentTooltip
                                            :label="'Packaging, Kitting and Handling'"
                                            :title="'Packaging, Kitting and Handling Breakdown'"
                                            :breakdown="getPackagingBreakdown()"
                                            :total="getPackagingTotal()"
                                            :format-price="icPriceFormat"
                                        />
                                        <span class="breakdown-value">
                                            {{
                                                icPriceFormat(
                                                    getPackagingTotal()
                                                )
                                            }}
                                        </span>
                                    </div>

                                    <div
                                        class="breakdown-item"
                                        v-if="getShippingTotal() > 0"
                                    >
                                        <PendingPaymentTooltip
                                            :label="'Shipping and Freight'"
                                            :title="'Shipping and Freight Breakdown'"
                                            :breakdown="getShippingBreakdown()"
                                            :total="getShippingTotal()"
                                            :format-price="icPriceFormat"
                                        />
                                        <span class="breakdown-value">
                                            {{
                                                icPriceFormat(
                                                    getShippingTotal()
                                                )
                                            }}
                                        </span>
                                    </div>

                                    <div
                                        class="breakdown-item"
                                        v-if="getSalesTaxTotal() > 0"
                                    >
                                        <PendingPaymentTooltip
                                            :label="'Sales Tax'"
                                            :title="'Sales Tax Breakdown'"
                                            :breakdown="getSalesTaxBreakdown()"
                                            :total="getSalesTaxTotal()"
                                            :format-price="icPriceFormat"
                                        />
                                        <span class="breakdown-value">
                                            {{
                                                icPriceFormat(
                                                    getSalesTaxTotal()
                                                )
                                            }}
                                        </span>
                                    </div>

                                    <div
                                        class="breakdown-item"
                                        style="
                                            border-top: 1px solid #e0e0e0;
                                            padding-top: 12px;
                                            margin-top: 8px;
                                        "
                                    >
                                        <span
                                            class="breakdown-label"
                                            style="font-weight: bold"
                                            >Grand Total</span
                                        >
                                        <span
                                            class="breakdown-value"
                                            style="font-weight: bold"
                                        >
                                            {{
                                                cartNotEmpty
                                                    ? icPriceFormat(
                                                          getGrandTotal()
                                                      )
                                                    : "$0.00"
                                            }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Show OrderDetails only if payment is already completed -->

                        <!-- v-show="cartNotEmpty" -->
                    </div>
                </div>
            </section>
        </div>

        <!--    <section class="cart_page pt-0" v-if="paymentAlradyCompleted">
            <div class="container">
                <div class="row">
                    <div class="col-md-4"></div>
                    <div class="col-md-4 tahnkyou_center">
                        <div>
                            <p>
                                You have already completed the payment for this order.
                                
                            </p>
                        </div>
                       
                    </div>
                    <div class="col-md-4"></div>
                </div>
            </div>
        </section>
         -->

        <!--   <section class="cart_page pt-0" v-if="thankyoupayment">
            <div class="container">
                <div class="row">
                    <div class="col-md-4"></div>
                    <div class="col-md-4 tahnkyou_center">
                        <div>
                            <h1>Thank you!</h1>
                            <p>
                                Your payment has been successfully processed. Your order is now being processed.
                                
                            </p>
                        </div>
                       
                    </div>
                    <div class="col-md-4"></div>
                </div>
            </div>
        </section> -->

        <!-- INSUFFICIENTS FUNDS -->
        <div
            class="modal login-form-popup fade payViaTerms_popup insufficient-form"
            id="insufficientFundsModal"
            tabindex="-1"
            aria-labelledby="payViaTerms"
            aria-hidden="true"
            data-keyboard="false"
            data-backdrop="static"
        >
            <div class="modal-dialog modal-dialog-centered modal-dialog">
                <div class="modal-content">
                    <div
                        class="modal-body"
                        style="overflow-y: auto"
                        v-if="term_payment_info"
                    >
                        <a
                            href="#"
                            class="popup-close"
                            id="popup-close-payViaTerms"
                            data-dismiss="modal"
                        >
                            <img src="/maincss/images/cancel.svg" alt=" " />
                        </a>
                        <div
                            class="login-form"
                            v-if="
                                parseFloat(grand_total_price) >
                                parseFloat(
                                    term_payment_info.avalaible_on_account
                                )
                            "
                        >
                            <h3>
                                Insufficient Funds
                                <span class="font-weight-bold">
                                    {{ icPriceFormat(insufficientFundsAmount) }}
                                </span>
                            </h3>
                            <p class="mb_20">
                                You don't have enough funds to buy this order
                                Please add a card
                            </p>

                            <!-- Show message if no saved cards available -->
                            <div
                                v-if="
                                    !all_payment_methods ||
                                    all_payment_methods.length === 0
                                "
                                class="mb_20"
                            >
                                <p class="text-center text-muted">
                                    No saved cards available. Please add a new
                                    card.
                                </p>
                            </div>

                            <div
                                class="radio_butoons_headding d-flex mt_0 mb_30 border-top-0 border-bottom"
                                v-for="(
                                    payment_methods, indx
                                ) in all_payment_methods"
                                :key="indx"
                                :style="
                                    payment_methods.expired_time < new Date()
                                        ? 'display:none !important'
                                        : ''
                                "
                            >
                                <p class="m-0">
                                    <input
                                        type="radio"
                                        :value="
                                            payment_methods.customerPaymentProfileId
                                        "
                                        :id="
                                            payment_methods.customerPaymentProfileId +
                                            'id'
                                        "
                                        :checked="
                                            payment_methods.customerPaymentProfileId ==
                                            card_info2.customerPaymentProfileId
                                        "
                                        name="radio-group"
                                        @change="
                                            selectRemainingPaySavedCard(
                                                payment_methods.customerPaymentProfileId,
                                                payment_methods.expired_time,
                                                $event
                                            )
                                        "
                                    />
                                    <label
                                        :for="
                                            payment_methods.customerPaymentProfileId +
                                            'id'
                                        "
                                        class="m-0"
                                    >
                                        **** **** ****
                                        <span class="cc_opa">
                                            {{
                                                payment_methods.payment
                                                    .creditCard.cardNumber
                                                    ? payment_methods.payment.creditCard.cardNumber.substr(
                                                          -4
                                                      )
                                                    : ""
                                            }}
                                        </span>
                                    </label>
                                </p>
                                <div
                                    class="ml-auto mr_6 cards_img"
                                    v-if="
                                        payment_methods.payment.creditCard
                                            .cardType == 'Visa'
                                    "
                                >
                                    <img
                                        :src="
                                            base_url +
                                            '/maincss/images/add_visa_logo.png'
                                        "
                                        alt=" "
                                    />
                                </div>

                                <div
                                    class="ml-auto mr_6 cards_img"
                                    v-else-if="
                                        payment_methods.payment.creditCard
                                            .cardType == 'MasterCard'
                                    "
                                >
                                    <img
                                        :src="
                                            base_url +
                                            '/maincss/images/master_card_logo.png'
                                        "
                                        alt=" "
                                    />
                                </div>

                                <div
                                    class="ml-auto mr_6 cards_img"
                                    v-else-if="
                                        payment_methods.payment.creditCard
                                            .cardType == 'JCB'
                                    "
                                >
                                    <img
                                        :src="
                                            base_url +
                                            '/maincss/images/jcb_logo.svg'
                                        "
                                        alt=" "
                                    />
                                </div>

                                <div
                                    class="ml-auto mr_6 cards_img"
                                    v-else-if="
                                        payment_methods.payment.creditCard
                                            .cardType == 'Discover'
                                    "
                                >
                                    <img
                                        :src="
                                            base_url +
                                            '/maincss/images/discover_logo.svg'
                                        "
                                        alt=" "
                                    />
                                </div>
                                <div
                                    class="ml-auto mr_6 cards_img"
                                    v-else-if="
                                        payment_methods.payment.creditCard
                                            .cardType == 'AmericanExpress'
                                    "
                                >
                                    <img
                                        :src="
                                            base_url +
                                            '/maincss/images/american_express_logo.svg'
                                        "
                                        alt=" "
                                    />
                                </div>

                                <div class="ml-auto mr_6 cards_img" v-else>
                                    <img
                                        :src="
                                            base_url +
                                            '/maincss/images/unknown_card_logo.svg'
                                        "
                                        alt=" "
                                    />
                                </div>
                            </div>

                            <!-- Add New Card Button - Show when no saved cards or always show -->
                            <div
                                class="card-pay pb_10 add_new_payment_card radio_butoons_headding d-flex mt_0 mb_30 border-top-0 border-bottom"
                            >
                                <a
                                    href="javascript:void(0);"
                                    class="payment_box d-flex justify-content-center align-items-center flex-column text-center h-100"
                                    data-keyboard="false"
                                    data-toggle="modal"
                                    data-target="#add_payment_method_model"
                                    @click="closePayViaTermsModal"
                                >
                                    <a
                                        ><img
                                            src="/maincss/images/plus.svg"
                                            alt=" "
                                            class="ml-auto mr_6"
                                        />Add New Card
                                    </a>
                                </a>
                                <img
                                    src="/maincss/images/cards.png"
                                    alt=" "
                                    class="ml-auto mr_6 cards_img"
                                />
                            </div>

                            <div
                                class="radio_butoons_headding mt_0 mb_30 border-top-0 border-bottom d-none"
                            >
                                <p class="m-0">
                                    <label for="test1" class="m-0"
                                        ><span class="cc_opa"
                                            >Credit card</span
                                        ></label
                                    >
                                </p>
                                <img
                                    src="/maincss/images/cards.png"
                                    alt=" "
                                    class="ml-auto mr_6 cards_img"
                                />
                            </div>

                            <form
                                method="POST"
                                data-vv-scope="insufficientForm"
                            >
                                <div class="two_input_one_row mt_36">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="Card Number"
                                            name="CardNumber"
                                            placeholder="Enter Card Number"
                                            :value="
                                                card_info2.cardnumber
                                                    ? '#### #### #### ' +
                                                      card_info2.cardnumber
                                                    : undefined
                                            "
                                            v-validate="'required|length:19'"
                                            data-vv-as="Card Number"
                                            disabled
                                        />
                                        <label class="select_option_label"
                                            >Card number</label
                                        >
                                        <span class="highlight"></span>
                                        <small
                                            class="form-text text-error text-left"
                                            v-show="
                                                errors.has(
                                                    'insufficientForm.CardNumber'
                                                )
                                            "
                                        >
                                            {{
                                                errors.first(
                                                    "insufficientForm.CardNumber"
                                                )
                                            }}
                                        </small>
                                    </div>

                                    <div
                                        class="card_detail_month_year_code d-flex align-items-baseline justify-content-between mt_24"
                                    >
                                        <div
                                            class="form-group position-relative expiration"
                                        >
                                            <label class="select_option_label"
                                                >Month</label
                                            >
                                            <select
                                                class="form-control bg-transparent"
                                                v-model="
                                                    card_info2.cardexpiremonth
                                                "
                                                name="Expiration Month"
                                                v-validate="'required'"
                                                data-vv-as="Expiration Month"
                                                disabled
                                            >
                                                <option
                                                    v-for="n in 12"
                                                    :value="
                                                        10 > n ? '0' + n : n
                                                    "
                                                    :key="n"
                                                    :disabled="
                                                        n <
                                                            new Date().getMonth() +
                                                                1 &&
                                                        changedYear <=
                                                            currentYear
                                                    "
                                                >
                                                    {{ 10 > n ? "0" + n : n }}
                                                </option>
                                            </select>
                                            <small
                                                class="form-text text-error text-left"
                                                v-show="
                                                    errors.has(
                                                        'insufficientForm.Expiration Month'
                                                    )
                                                "
                                            >
                                                {{
                                                    errors.first(
                                                        "insufficientForm.Expiration Month"
                                                    )
                                                }}
                                            </small>
                                        </div>

                                        <div
                                            class="form-group position-relative expiration"
                                        >
                                            <label class="select_option_label"
                                                >Year</label
                                            >
                                            <select
                                                class="form-control bg-transparent"
                                                v-model="
                                                    card_info2.cardexpireyear
                                                "
                                                name="Expiration Year"
                                                v-validate="'required'"
                                                data-vv-as="Expiration Year"
                                                disabled
                                                @change="changeCardYear($event)"
                                            >
                                                <option
                                                    v-for="year in years"
                                                    :key="year"
                                                    :value="
                                                        year
                                                            ? year
                                                                  .toString()
                                                                  .substr(-2)
                                                            : ''
                                                    "
                                                >
                                                    {{ year }}
                                                </option>
                                            </select>
                                            <small
                                                class="form-text text-error text-left"
                                                v-show="
                                                    errors.has(
                                                        'insufficientForm.Expiration Year'
                                                    )
                                                "
                                            >
                                                {{
                                                    errors.first(
                                                        "insufficientForm.Expiration Year"
                                                    )
                                                }}
                                            </small>
                                        </div>

                                        <div class="form-group securit_code">
                                            <span class="position-relative">
                                                <input
                                                    maxlength="3"
                                                    type="password"
                                                    class="form-control"
                                                    id="Security Code"
                                                    placeholder="Enter Code "
                                                    name="Security Code"
                                                    v-model="
                                                        card_info2.cardsecuritycode
                                                    "
                                                    v-validate="
                                                        'required|numeric|length:3'
                                                    "
                                                    @input="cardSecurityFormat"
                                                />
                                            </span>
                                            <label class="select_option_label"
                                                >Security code
                                                <div
                                                    class="alert-icon pb-2 security_alert_icon"
                                                    data-toggle="tooltip"
                                                    data-placement="bottom"
                                                    v-tooltip="
                                                        'Credit Card Security Code'
                                                    "
                                                >
                                                    <img
                                                        src="/maincss/images/information.svg"
                                                        alt=" "
                                                    /></div
                                            ></label>

                                            <span class="highlight"></span>
                                            <small
                                                class="form-text text-error text-left"
                                                v-show="
                                                    errors.has(
                                                        'insufficientForm.Security Code'
                                                    )
                                                "
                                            >
                                                {{
                                                    errors.first(
                                                        "insufficientForm.Security Code"
                                                    )
                                                }}
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="payviaterms_btn_box d-flex align-items-baseline justify-content-end mt_34 mb_0"
                                >
                                    <button
                                        data-dismiss="modal"
                                        class="btn btn_outline_primary border_primary_blue text_primary_blue design-studio-header"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        @click="payRemainingAmount"
                                        class="btn btn_orange bg_primary_orange text_white w-auto ml_20 btn_h60"
                                    >
                                        Select Card
                                        <!-- <span
                                            v-if="
                                                term_payment_info.avalaible_on_account >
                                                    0 &&
                                                grand_total_price <=
                                                    term_payment_info.avalaible_on_account
                                            "
                                        >
                                            {{
                                                icPriceFormat(
                                                    term_payment_info.avalaible_on_account -
                                                        grand_total_price
                                                )
                                            }}
                                        </span>
                                        <span
                                            v-else-if="
                                                term_payment_info.avalaible_on_account >
                                                    0 &&
                                                grand_total_price >
                                                    term_payment_info.avalaible_on_account
                                            "
                                        >
                                            {{
                                                icPriceFormat(
                                                    grand_total_price -
                                                        term_payment_info.avalaible_on_account
                                                )
                                            }}
                                        </span>
                                        <span v-else>
                                            {{
                                                icPriceFormat(grand_total_price)
                                            }}
                                        </span> -->
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ADD NEW PAYMENT MODEL-->
        <div
            class="modal login-form-popup fade h-auto payment_popup"
            id="add_payment_method_model"
            tabindex="-1"
            aria-labelledby="address"
            aria-hidden="true"
            data-keyboard="false"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable payment"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title">Add New Payment Method</h3>
                        <a
                            href="#"
                            @click="resetCard"
                            class="popup-close"
                            id="popup-close-paymentform"
                            data-dismiss="modal"
                        >
                            <img src="/maincss/images/cancel.svg" alt=" " />
                        </a>
                    </div>
                    <div class="modal-body">
                        <div class="address-form">
                            <form method="post" data-vv-scope="addpaymentform">
                                <div class="form-group">
                                    <div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="cardnumber"
                                            name="cardnumber"
                                            placeholder="Enter Card Number"
                                            v-model="new_card.cardnumber"
                                            v-validate="'required|credit_card'"
                                            data-vv-as="Card Number"
                                            v-mask="
                                                masklength == null
                                                    ? '#### #### #### #'
                                                    : masklength == 14
                                                    ? '#### #### #### ##'
                                                    : masklength == 15
                                                    ? '#### ###### #####'
                                                    : masklength == 16
                                                    ? '#### #### #### ####'
                                                    : masklength == 17
                                                    ? '#### #### #### ####'
                                                    : '#### #### #### ####'
                                            "
                                            @input="cardNumberFormat"
                                        />
                                    </div>
                                    <label style="margin-top: -20px"
                                        >Card Number</label
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <small
                                        class="form-text text-error text-left"
                                        v-show="
                                            errors.has(
                                                'addpaymentform.cardnumber'
                                            )
                                        "
                                    >
                                        {{
                                            errors.first(
                                                "addpaymentform.cardnumber"
                                            )
                                        }}
                                    </small>
                                </div>
                                <div class="form-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="cardholdername"
                                        maxlength="80"
                                        name="cardholdername"
                                        v-model="new_card.cardholdername"
                                        v-validate="'required|max:50'"
                                        data-vv-as="Card Holder"
                                        placeholder="Enter Card Holder Name"
                                    />
                                    <label class="card-holder"
                                        >Card Holder</label
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <small
                                        class="form-text text-error text-left"
                                        v-show="
                                            errors.has(
                                                'addpaymentform.cardholdername'
                                            )
                                        "
                                    >
                                        {{
                                            errors.first(
                                                "addpaymentform.cardholdername"
                                            )
                                        }}
                                    </small>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label
                                                style="margin-top: -20px"
                                                class="select_option_label"
                                                >Month</label
                                            >
                                            <select
                                                class="form-control bg-transparent"
                                                v-model="
                                                    new_card.cardexpiremonth
                                                "
                                                name="Expiration Month"
                                                v-validate="'required'"
                                                data-vv-as="Expiration Month"
                                            >
                                                <option
                                                    v-for="n in 12"
                                                    :value="
                                                        10 > n ? '0' + n : n
                                                    "
                                                    :key="n"
                                                    :disabled="
                                                        (n <
                                                            (
                                                                '0' +
                                                                (new Date().getMonth() +
                                                                    1)
                                                            ).slice(-2) &&
                                                            changedYear <=
                                                                currentYear) ||
                                                        new_card.cardexpireyear <
                                                            currentYear
                                                    "
                                                >
                                                    {{ 10 > n ? "0" + n : n }}
                                                </option>
                                            </select>
                                            <small
                                                class="form-text text-error text-left"
                                                v-show="
                                                    errors.has(
                                                        'addpaymentform.Expiration Month'
                                                    )
                                                "
                                            >
                                                {{
                                                    errors.first(
                                                        "addpaymentform.Expiration Month"
                                                    )
                                                }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label
                                                style="margin-top: -20px"
                                                class="select_option_label"
                                                >Year</label
                                            >
                                            <select
                                                class="form-control bg-transparent"
                                                v-model="
                                                    new_card.cardexpireyear
                                                "
                                                name="Expiration Year"
                                                v-validate="'required'"
                                                data-vv-as="Expiration Year"
                                                @change="
                                                    changeCardYear(
                                                        $event,
                                                        new_card
                                                    )
                                                "
                                            >
                                                <option
                                                    v-for="year in years"
                                                    :key="year"
                                                    :value="
                                                        year
                                                            .toString()
                                                            .substr(-2)
                                                    "
                                                    :disabled="
                                                        year
                                                            .toString()
                                                            .substr(-2) <
                                                        currentYear
                                                    "
                                                >
                                                    {{ year }}
                                                </option>
                                            </select>
                                            <small
                                                class="form-text text-error text-left"
                                                v-show="
                                                    errors.has(
                                                        'addpaymentform.Expiration Year'
                                                    )
                                                "
                                            >
                                                {{
                                                    errors.first(
                                                        "addpaymentform.Expiration Year"
                                                    )
                                                }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn_outline_primary border_primary_blue cancel"
                            data-dismiss="modal"
                            @click="resetCard"
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            @click="addNewPaymentMethod"
                            class="btn btn_orange bg_primary_orange text_white ml_10 add"
                        >
                            Add
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="preloader" v-show="isLoader">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon class="rect" points="0 0 0 40 40 40 40 0" />
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import OrderDetails from "@/components/payments/OrderDetails";
import ShippingPayment from "@/components/ShippingPayment";
import PaymentShipment from "@/components/payments/PaymentShipmentV2";
import ReviewPay from "@/components/ReviewPay";
import ApiService from "@/common/api.service";
import DisplayProductImage from "@/components/DisplayProductImageNew";
import { rollupFeeMixin } from "@/common/rollupFee.service";
import PendingPaymentTooltip from "@/views/frontend/cart_checkout/v3/components/PendingPaymentTooltip.vue";
import OrderItemsByAddress from "@/views/frontend/account/components/OrderItemsByAddress.vue";
export default {
    /* eslint-disable */
    name: "Checkout",
    /* eslint-enable */
    mixins: [rollupFeeMixin],
    components: {
        ShippingPayment,
        ReviewPay,
        PaymentShipment,
        OrderDetails,
        DisplayProductImage,
        PendingPaymentTooltip,
        OrderItemsByAddress
    },
    data() {
        return {
            showCartSummaryComponent: false,
            total_non_standard_colors: [],
            isLoader: false,
            order_data: null,
            order: null,
            customer_data: {
                firstName: "",
                lastName: "",
                fullname: "",
                email: "",
                phone: "",
                user_id: 0,
                netsuite_id: ""
            },
            billing_address_data: {
                first_name: "",
                last_name: "",
                address_label: "",
                address1: "",
                address2: "",
                state: "",
                city: "",
                country: "",
                pincode: ""
            },
            shipping_address_data: {
                first_name: "",
                last_name: "",
                shippingaddress_label: "",
                address1: "",
                address2: "",
                state: "",
                city: "",
                country: "",
                pincode: ""
            },
            new_card: {
                id: "",
                cardtype: "",
                cardimage: "",
                cardnumber: "",
                cardholdername: "",
                cardexpiremonth: ("0" + (new Date().getMonth() + 1)).slice(-2),
                cardexpireyear: new Date().getFullYear().toString().substr(-2),
                cardsecuritycode: ""
            },
            selected_card: {
                customerProfileId: "",
                customerPaymentProfileId: "",
                cardtype: "",
                cardsecuritycode: "",
                cardnumber: "",
                cardexpiremonth: ("0" + (new Date().getMonth() + 1)).slice(-2),
                cardexpireyear: new Date().getFullYear().toString().substr(-2)
            },
            card_info2: {
                id: "",
                cardtype: "",
                cardimage: "",
                cardnumber: "",
                cardholdername: "",
                cardexpiremonth: ("0" + (new Date().getMonth() + 1)).slice(-2), //new Date().getMonth() + 1,
                cardexpireyear: new Date().getFullYear().toString().substr(-2)
            },

            grand_total_price: 0,
            placeorder_add_card: true,
            masklength: "",
            base_url: window.location.origin,
            currentYear: new Date().getFullYear().toString().substr(-2), //For Card Expiry Year
            changedYear: "",
            thankyoupayment: false,
            paymentAlradyCompleted: false,
            items: "",
            all_payment_methods: [],
            credit_limit: null,
            credit_reduce: null,
            insufficient_amount: null,
            po_number: "",
            is_saved_card: false,
            is_pay_way_terms: false,
            is_remaining_pay_card: false,
            remaining_pay_card_details: null,
            term_payment_details: null,
            card_payment_details: null,
            unsynced_orders_amount: 0,
            total_orders: 0,
            term_payment_info: {
                creditlimit: 0,
                overdue_balance: 0,
                unbilled_orders: 0,
                unpaid_invoices: 0,
                avalaible_on_account: 0,
                unapplied_credits: 0
            },

            // Post-payment tabs (match frontend Order_detail.vue)
            activeTab: "items",
            processedOrderData: null
        };
    },
    mounted() {
        var _this = this;
        document.body.classList.add("bg_primary_light_white");
        _this.onLoadPage();

        // Add event listener for insufficientFundsModal shown event to refresh payment methods
        $("#insufficientFundsModal").on("shown.bs.modal", function () {
            _this.onInsufficientFundsModalShown();
        });
    },

    computed: {
        ...mapGetters(["isAuthenticatedClient", "currentUserClient"]),
        hasSplitShipments() {
            const s =
                this.order_data &&
                this.order_data.NewOrderSplitItems &&
                Array.isArray(this.order_data.NewOrderSplitItems)
                    ? this.order_data.NewOrderSplitItems
                    : [];
            return s.length > 0;
        },
        orderAddressesAll() {
            return this.order_data && this.order_data.NewOrderAddresses
                ? this.order_data.NewOrderAddresses
                : [];
        },
        orderSplitItems() {
            return this.order_data && this.order_data.NewOrderSplitItems
                ? this.order_data.NewOrderSplitItems
                : [];
        },
        itemsByAddress() {
            const map = {};
            const seenSplitKeys = new Set();
            (this.orderSplitItems || []).forEach((split) => {
                const addrId = split && split.split_address_id;
                if (!addrId) return;

                // Guard against duplicate split rows coming from API payload merges.
                const splitKey =
                    split && split.id != null
                        ? `id:${split.id}`
                        : [
                              addrId,
                              split && split.order_item_id,
                              split && split.split_quantity,
                              split && split.name_and_number_json
                          ].join("|");
                if (seenSplitKeys.has(splitKey)) return;
                seenSplitKeys.add(splitKey);

                if (!map[addrId]) map[addrId] = [];

                let baseItem = null;
                let sizeRow = null;
                const targetId = split.order_item_id;

                const grouped =
                    (this.processedOrderData && this.processedOrderData.items) ||
                    [];
                (grouped || []).some((g) => {
                    if (!g || !Array.isArray(g.sizes)) return false;
                    const found = g.sizes.find((s) => s && s.id === targetId);
                    if (found) {
                        baseItem = g;
                        sizeRow = found;
                        return true;
                    }
                    return false;
                });

                if (!baseItem) return;

                map[addrId].push({
                    split,
                    item: baseItem,
                    sizeLabel:
                        (sizeRow &&
                            sizeRow.MainNewSubProduct &&
                            sizeRow.MainNewSubProduct.Size &&
                            sizeRow.MainNewSubProduct.Size.size) ||
                        "",
                    name: "",
                    number: ""
                });
            });

            // Standard (non-split) orders: show all items under default shipping address.
            if (Object.keys(map).length === 0) {
                const list = this.orderAddressesAll || [];
                const fallbackAddress =
                    list.find((a) => Number(a && a.is_default) === 1) ||
                    list.find((a) => Number(a && a.split_address_sequence) === 1) ||
                    list.find((a) => Number(a && a.is_shipping) === 1) ||
                    list[0] ||
                    null;
                const fallbackAddressId = fallbackAddress && fallbackAddress.id;
                if (fallbackAddressId != null) {
                    const addrKey = String(fallbackAddressId);
                    map[addrKey] = [];
                    const grouped =
                        (this.processedOrderData && this.processedOrderData.items) || [];
                    (grouped || []).forEach((item) => {
                        const sizes = Array.isArray(item && item.sizes) ? item.sizes : [];
                        const hasChildRows = sizes.some(
                            (s) =>
                                (parseInt(s && s.quantity, 10) || 0) > 0 &&
                                Number(s && s.parent) !== 1
                        );
                        sizes.forEach((sizeRow) => {
                            const qty = parseInt(sizeRow && sizeRow.quantity, 10) || 0;
                            if (qty <= 0) return;
                            if (hasChildRows && Number(sizeRow && sizeRow.parent) === 1) {
                                return;
                            }
                            const sizeLabel =
                                (sizeRow &&
                                    sizeRow.MainNewSubProduct &&
                                    sizeRow.MainNewSubProduct.Size &&
                                    sizeRow.MainNewSubProduct.Size.size) ||
                                (sizeRow && sizeRow.size) ||
                                "";
                            map[addrKey].push({
                                split: {
                                    split_quantity: qty,
                                    estimated_shipping_date:
                                        (sizeRow && sizeRow.estimated_shipping_date) ||
                                        item.estimated_shipping_date ||
                                        null,
                                    name_and_number_json: item.name_and_number_json
                                },
                                item,
                                sizeLabel,
                                name: "",
                                number: ""
                            });
                        });
                    });
                }
            }
            return map;
        },
        addressesWithSplits() {
            const all = this.orderAddressesAll || [];
            const map = this.itemsByAddress || {};
            const idsWithSplits = new Set(
                Object.keys(map).map((id) => parseInt(id, 10))
            );
            const splitAddresses = all.filter(
                (addr) => addr && idsWithSplits.has(parseInt(addr.id, 10))
            );
            if (splitAddresses.length > 0) {
                return splitAddresses;
            }
            const fallbackAddress =
                all.find((a) => Number(a && a.is_default) === 1) ||
                all.find((a) => Number(a && a.split_address_sequence) === 1) ||
                all.find((a) => Number(a && a.is_shipping) === 1) ||
                all[0] ||
                null;
            return fallbackAddress ? [fallbackAddress] : [];
        },
        orderItemsGrouped() {
            return this.processedOrderData && this.processedOrderData.items
                ? this.processedOrderData.items
                : [];
        },
        orderItemsBaseFeeTotal() {
            return (this.orderItemsGrouped || []).reduce(
                (sum, item) => sum + (this.getBaseFeeTotal(item) || 0),
                0
            );
        },
        orderItemsRunChargeTotal() {
            return (this.orderItemsGrouped || []).reduce(
                (sum, item) => sum + (this.getRunChargeTotal(item) || 0),
                0
            );
        },
        orderItemsSetupDesignTotal() {
            return (this.orderItemsGrouped || []).reduce((sum, item) => {
                const setup = this.getSetupFeesTotal(item) || 0;
                const design = parseFloat(item && item.design_fee) || 0;
                return sum + setup + design;
            }, 0);
        },
        costSummaryByAddress() {
            if (!this.processedOrderData) return null;
            return {
                baseFeeTotal: this.orderItemsBaseFeeTotal || 0,
                baseFeeLabel:
                    (this.getRollupFeeDisplayName &&
                        this.getRollupFeeDisplayName(1)) ||
                    "Base Fee",
                runChargeTotal: this.orderItemsRunChargeTotal || 0,
                runChargeLabel:
                    (this.getRollupFeeDisplayName &&
                        this.getRollupFeeDisplayName(12)) ||
                    "Run Charge",
                setupDesignTotal: this.orderItemsSetupDesignTotal || 0,
                setupDesignLabel:
                    (this.getRollupFeeDisplayName &&
                        this.getRollupFeeDisplayName(2)) ||
                    "Set Up and Design",
                packingTotal: this.getPackagingTotal(),
                packingBreakdown: this.getPackagingBreakdown() || [],
                packingLabel:
                    (this.getRollupFeeDisplayName &&
                        this.getRollupFeeDisplayName(5)) ||
                    "Packaging, Kitting and Handling",
                shippingTotal: this.getShippingTotal(),
                shippingBreakdown: this.getShippingBreakdown() || [],
                shippingLabel:
                    (this.getRollupFeeDisplayName &&
                        this.getRollupFeeDisplayName(4)) ||
                    "Shipping and Freight",
                salesTaxTotal: this.getSalesTaxTotal(),
                salesTaxBreakdown: this.getSalesTaxBreakdown() || [],
                salesTaxLabel:
                    (this.getRollupFeeDisplayName &&
                        this.getRollupFeeDisplayName(3)) ||
                    "Sales Tax",
                grandTotal: this.getGrandTotal()
            };
        },
        hasValidPaymentMethods() {
            // Check if there are any non-expired payment methods
            if (
                !this.all_payment_methods ||
                this.all_payment_methods.length === 0
            ) {
                return false;
            }
            const now = new Date();
            return this.all_payment_methods.some(
                (method) =>
                    method.expired_time && new Date(method.expired_time) >= now
            );
        },
        tag() {
            return this.$route.params.tag;
        },
        years() {
            const year = new Date().getFullYear();
            return Array.from({ length: 15 }, (value, index) => year + index);
        },
        paymentId() {
            return this.$route.params.payment_pending_id; // Get ID from URL
        },
        cartNotEmpty() {
            return (
                this.order_data &&
                this.order_data.items &&
                this.order_data.items.length > 0
            );
        },
        insufficientFundsAmount() {
            // If available account is positive but less than order total, show remaining amount
            let remainingAmount;
            if (this.term_payment_info.avalaible_on_account > 0) {
                remainingAmount =
                    parseFloat(this.grand_total_price) -
                    parseFloat(this.term_payment_info.avalaible_on_account);
            } else {
                remainingAmount = parseFloat(this.grand_total_price);
            }
            return remainingAmount;
        }
    },
    methods: {
        // ---- Item breakdown helpers (admin/frontend parity) ----
        getBreakdownData(item, field) {
            if (item && item[field] !== undefined && item[field] !== null) {
                if (Array.isArray(item[field]) || typeof item[field] === "object") {
                    return item[field];
                }
                if (typeof item[field] === "string") {
                    try {
                        return JSON.parse(item[field]);
                    } catch (e) {
                        return null;
                    }
                }
                return item[field];
            }
            if (
                item &&
                item.sizes &&
                item.sizes.length > 0 &&
                item.sizes[0] &&
                item.sizes[0][field]
            ) {
                if (typeof item.sizes[0][field] === "string") {
                    try {
                        return JSON.parse(item.sizes[0][field]);
                    } catch (e) {
                        return null;
                    }
                }
                if (
                    Array.isArray(item.sizes[0][field]) ||
                    typeof item.sizes[0][field] === "object"
                ) {
                    return item.sizes[0][field];
                }
                return item.sizes[0][field];
            }
            return null;
        },
        getBaseFeeTotal(item) {
            const baseFee = this.getBreakdownData(item, "base_fee");
            if (!baseFee || !Array.isArray(baseFee)) return 0;
            let total = 0;
            baseFee.forEach((fee) => {
                if (fee && fee.total) {
                    const t = parseFloat(fee.total);
                    if (!isNaN(t)) total += t;
                }
            });
            return total;
        },
        getRunChargeTotal(item) {
            const runCharge = this.getBreakdownData(item, "run_charge_breakdown");
            if (!runCharge || !Array.isArray(runCharge)) return 0;
            let total = 0;
            runCharge.forEach((b) => {
                if (b.items && Array.isArray(b.items)) {
                    b.items.forEach((it) => {
                        if (
                            it.type === "total" &&
                            it.total &&
                            it.total !== "INCL"
                        ) {
                            total += parseFloat(it.total) || 0;
                        } else if (
                            it.total &&
                            it.total !== "INCL" &&
                            !it.isIncluded
                        ) {
                            total += parseFloat(it.total) || 0;
                        }
                    });
                }
                if (b.type === "otherService" && b.total && b.total !== "INCL") {
                    total += parseFloat(b.total) || 0;
                }
            });
            return total;
        },
        getSetupFeesTotal(item) {
            const setupFees = this.getBreakdownData(item, "setup_fees_details");
            if (!setupFees || typeof setupFees !== "object") return 0;
            return setupFees.total ? parseFloat(setupFees.total) || 0 : 0;
        },
        async onLoadPage() {
            this.isLoader = true;
            await this.getOrderDetail();
            this.isLoader = false;
            //
        },

        getAllPaymentMethods() {
            return new Promise((resolve, reject) => {
                let user_id = this.customer_data.user_id;
                ApiService.query("/getAllPaymentMethods1", {
                    params: { user_id }
                })
                    .then(({ data }) => {
                        if (!data.success) {
                            this.isLoader = false;
                            /*  this.$toast.error(data.error, {
                                    position: "top-right",
                                    queue: true
                                }); */
                            return;
                        }
                        // Create a new array to ensure Vue reactivity
                        this.all_payment_methods = data.all_payment_methods
                            ? [...data.all_payment_methods]
                            : [];
                        this.all_payment_methods.forEach((method) => {
                            let expiration_date =
                                method.payment.creditCard.expirationDate;
                            method.expired_time = new Date(
                                expiration_date.split("-")[0],
                                expiration_date.split("-")[1],
                                0
                            );
                        });

                        // Force Vue to update the component
                        this.$nextTick(() => {
                            this.$forceUpdate();
                        });

                        if (
                            this.all_payment_methods &&
                            this.all_payment_methods.length > 0
                        ) {
                            this.selectPaymentMethod(
                                this.all_payment_methods[0]
                                    .customerPaymentProfileId,
                                this.all_payment_methods[0].expired_time
                            );
                        }
                        resolve(data);
                    })
                    .catch((err) => {
                        console.log(err);
                        this.isLoader = false;
                        reject(err);
                    });
            });
        },

        async prepareData() {
            let billing_address;
            let shipping_address;

            if (this.order.NewOrderAddresses.length == 1) {
                billing_address = this.order.NewOrderAddresses[0];
                shipping_address = this.order.NewOrderAddresses[0];
            } else if (this.order.NewOrderAddresses.length > 1) {
                billing_address = this.order.NewOrderAddresses[0];
                shipping_address = this.order.NewOrderAddresses[1];
            }

            if (billing_address) {
                this.billing_address_data = {
                    first_name: billing_address.first_name,
                    last_name: billing_address.last_name,
                    address_label: billing_address.company_name,
                    address1: billing_address.address_line1,
                    address2: billing_address.address_line2,
                    state: billing_address.state,
                    city: billing_address.city,
                    country: billing_address.country,
                    pincode: billing_address.zip
                };

                this.customer_data.fullname = billing_address.fullname;
            }

            if (shipping_address) {
                this.shipping_address_data = {
                    first_name: shipping_address.first_name,
                    last_name: shipping_address.last_name,
                    shippingaddress_label: shipping_address.company_name,
                    address1: shipping_address.address_line1,
                    address2: shipping_address.address_line2,
                    state: shipping_address.state,
                    city: shipping_address.city,
                    country: shipping_address.country,
                    pincode: shipping_address.zip
                };
            }
            this.customer_data.firstName = this.order.User.first_name;
            this.customer_data.lastName = this.order.User.last_name;
            this.customer_data.email = this.order.User.email;
            this.customer_data.phone = this.order.User.mobile;
            this.grand_total_price = this.order.total_price;
            this.customer_data.user_id = this.order.user_id;
            this.customer_data.netsuite_id = this.order.User.netsuite_id;

            // Await all async operations to ensure they complete before turning off loader
            await Promise.all([
                this.getCustomerDetailsFromNetsuite(
                    this.customer_data.netsuite_id
                ),
                this.getCustomerTermDetails(this.customer_data.netsuite_id),
                this.getOrdersCount(),
                this.getAllPaymentMethods()
            ]);

            this.po_number = this.order.po_number;
        },
        removeCircularReferences(obj) {
            const seen = new WeakSet();
            return JSON.parse(
                JSON.stringify(obj, (key, value) => {
                    if (typeof value === "object" && value !== null) {
                        if (seen.has(value)) return undefined;
                        seen.add(value);
                    }
                    return value;
                })
            );
        },

        async getOrderDetail() {
            var _this = this;
            this.isLoader = true;
            _this.isBusy = true;
            return new Promise(async (resolve) => {
                try {
                    const { data } = await ApiService.get(
                        "/neworderdetailbypendingid/" + this.paymentId
                    );

                    if (!data.success) {
                        this.isLoader = false;
                        this.isBusy = false;
                        this.$toast.error(data.error, {
                            position: "top-right",
                            queue: true
                        });
                        resolve(data);
                        return;
                    }

                    let order = data.order;
                    _this.order = order;
                    console.log("order", order);

                    const shippingAddresses = (order.NewOrderAddresses || []).filter(
                        (a) =>
                            a &&
                            (a.is_shipping === 1 ||
                                a.is_shipping === true ||
                                a.is_shipping === "1")
                    );
                    const isSplitShipmentOrder =
                        shippingAddresses.length > 1 ||
                        shippingAddresses.some(
                            (a) =>
                                a.split_address_sequence &&
                                parseInt(a.split_address_sequence) > 0
                        );

                    let paymentStatus = order.NewOrderPayments.find(
                        (payment) =>
                            payment.status == "Completed" &&
                            payment.is_additional_payment == 0
                    );
                    if (
                        paymentStatus &&
                        paymentStatus.status == "Completed" &&
                        paymentStatus.is_additional_payment == 0
                    ) {
                        //  this.$toast.error("dddd", { position: 'top-right', queue: true });
                        this.paymentAlradyCompleted = true;
                        this.$nextTick(() => {
                            window.scrollTo({ top: 0, behavior: "smooth" });
                        });
                        //return;
                    }
                    let order_items = [];
                    let all_setup_fee = 0;
                    let all_color_fee = 0;
                    let subtotal = 0;
                    let front_art_url;
                    let total_non_standard_colors = [];
                    data.order.NewOrderItems.forEach((item) => {
                        const mainProduct =
                            item &&
                            item.MainNewSubProduct &&
                            (item.MainNewSubProduct.MainNewProducts ||
                                item.MainNewSubProduct.MainNewProduct);
                        if (item.MainNewSubProduct && mainProduct) {
                            let item_setup_fee = 0;
                            let color_fee = 0;
                            // Create a copy of product to preserve all properties
                            let order_item = {
                                ...mainProduct
                            };
                            // Ensure name and other essential properties are preserved
                            // Use product_number as fallback if name is missing
                            order_item.name =
                                mainProduct.name || mainProduct.product_number ||
                                "Product";
                            order_item.id = mainProduct.id;
                            order_item.product_number =
                                mainProduct.product_number;
                            order_item.Category =
                                mainProduct.Category;
                            order_item.Vendor =
                                (mainProduct && mainProduct.Vendor) ||
                                null;
                            order_item.gender_size_id = item.gender_size_id;
                            order_item.unique_item_id = item.unique_item_id;
                            order_item.color = item.MainNewSubProduct.Color;
                            const baseGroupKey = [
                                item.MainNewSubProduct.parent_product_id,
                                item.MainNewSubProduct.color_id,
                                item.gender_size_id,
                                item.build_id || "",
                                item.design_image || ""
                            ].join("|");
                            order_item._groupKey = isSplitShipmentOrder
                                ? baseGroupKey
                                : baseGroupKey + "|" + (item.unique_item_id || "");
                            order_item["NewOrderItemDecoration"] =
                                item.NewOrderItemDecorations &&
                                item.NewOrderItemDecorations.length > 0
                                    ? item.NewOrderItemDecorations[0]
                                    : null;
                            let index = order_items.findIndex(
                                (item_data) =>
                                    item_data &&
                                    item_data._groupKey === order_item._groupKey
                            );
                            item_setup_fee =
                                item_setup_fee + parseFloat(item.setup_fee);
                            // Subtotal will be calculated from item_sub_total after grouping
                            if (index >= 0 && order_items[index]) {
                                order_items[index]["sizes"].push(item);
                                order_items[index]["total_quantity"] +=
                                    item.quantity;
                                order_items[index]["total_price"] +=
                                    parseFloat(item.total_price) +
                                    parseFloat(item.discount);
                                order_items[index]["total_discount"] +=
                                    parseFloat(item.discount);
                                order_items[index]["total_extra_fees"] +=
                                    parseFloat(item["single_location_price"]) *
                                    parseFloat(item["quantity"]);
                                order_items[index][
                                    "total_single_location_price"
                                ] +=
                                    parseFloat(item.single_location_price) *
                                    parseFloat(item["quantity"]);
                                // For grouped items, sum item_sub_total from all sizes
                                if (item.item_sub_total) {
                                    if (!order_items[index]["item_sub_total"]) {
                                        order_items[index][
                                            "item_sub_total"
                                        ] = 0;
                                    }
                                    order_items[index]["item_sub_total"] +=
                                        parseFloat(item.item_sub_total || 0);
                                }
                                // Parse decoration field for grouped items
                                if (
                                    !order_items[index]["decoration"] &&
                                    item.decoration
                                ) {
                                    order_items[index]["decoration"] =
                                        item.decoration
                                            ? typeof item.decoration ===
                                              "string"
                                                ? JSON.parse(item.decoration)
                                                : item.decoration
                                            : null;
                                }
                                // Copy NewOrderItemDecoration for grouped items if not already set
                                if (
                                    !order_items[index][
                                        "NewOrderItemDecoration"
                                    ] &&
                                    item.NewOrderItemDecorations &&
                                    item.NewOrderItemDecorations.length > 0
                                ) {
                                    order_items[index][
                                        "NewOrderItemDecoration"
                                    ] = item.NewOrderItemDecorations[0];
                                }
                                // Copy patch cost details for grouped items if not already set
                                if (
                                    !order_items[index][
                                        "patch_cost_details"
                                    ] &&
                                    item.patch_cost_details
                                ) {
                                    order_items[index][
                                        "patch_cost_details"
                                    ] =
                                        typeof item.patch_cost_details ===
                                        "string"
                                            ? JSON.parse(
                                                  item.patch_cost_details
                                              )
                                            : item.patch_cost_details;
                                }
                                if (
                                    !order_items[index]["patch_cost"] &&
                                    parseFloat(item.patch_cost || 0) > 0
                                ) {
                                    order_items[index]["patch_cost"] =
                                        parseFloat(item.patch_cost || 0);
                                }
                                // Font/color for name & number (for OrderDetails) - use first item's if not set
                                if (
                                    !order_items[index][
                                        "font_color_sizes_name"
                                    ] &&
                                    item.font_color_sizes_name
                                ) {
                                    order_items[index][
                                        "font_color_sizes_name"
                                    ] =
                                        typeof item.font_color_sizes_name ===
                                        "string"
                                            ? JSON.parse(
                                                  item.font_color_sizes_name
                                              )
                                            : item.font_color_sizes_name;
                                }
                                if (
                                    !order_items[index][
                                        "font_color_sizes_number"
                                    ] &&
                                    item.font_color_sizes_number
                                ) {
                                    order_items[index][
                                        "font_color_sizes_number"
                                    ] =
                                        typeof item.font_color_sizes_number ===
                                        "string"
                                            ? JSON.parse(
                                                  item.font_color_sizes_number
                                              )
                                            : item.font_color_sizes_number;
                                }
                            } else {
                                order_item["sizes"] = [item];

                                order_item["total_quantity"] = item.quantity;
                                order_item["setup_fee"] = item_setup_fee;
                                order_item["total_price"] =
                                    parseFloat(item.total_price) +
                                    parseFloat(item.discount);
                                order_item["total_discount"] = parseFloat(
                                    item.discount
                                );
                                order_item["design_fee"] = parseFloat(
                                    item.design_fee
                                );
                                order_item["patch_cost"] = parseFloat(
                                    item.patch_cost || 0
                                );
                                order_item["patch_cost_details"] = item.patch_cost_details
                                    ? (typeof item.patch_cost_details === "string"
                                        ? JSON.parse(item.patch_cost_details)
                                        : item.patch_cost_details)
                                    : null;
                                order_item["name_number_fees"] = parseFloat(
                                    item.name_number_fees
                                );
                                order_item["non_standard_fees"] = parseFloat(
                                    item.non_standard_fees
                                );
                                order_item["item_sub_total"] =
                                    item.item_sub_total
                                        ? parseFloat(item.item_sub_total)
                                        : null;
                                order_item["non_standard_colors"] =
                                    item.non_standard_colors
                                        ? JSON.parse(item.non_standard_colors)
                                        : [];
                                order_item["decoration_colors"] =
                                    item.decoration_colors
                                        ? JSON.parse(item.decoration_colors)
                                        : [];
                                // Parse decoration field
                                order_item["decoration"] = item.decoration
                                    ? typeof item.decoration === "string"
                                        ? JSON.parse(item.decoration)
                                        : item.decoration
                                    : null;
                                // Set NewOrderItemDecoration for non-grouped items
                                if (!order_item["NewOrderItemDecoration"]) {
                                    order_item["NewOrderItemDecoration"] =
                                        item.NewOrderItemDecorations &&
                                        item.NewOrderItemDecorations.length > 0
                                            ? item.NewOrderItemDecorations[0]
                                            : null;
                                }
                                // order_item.artwork_colors = [...new Set(order_item.standard_colors.concat(order_item.non_standard_colors))];
                                total_non_standard_colors =
                                    total_non_standard_colors.concat(
                                        order_item["non_standard_colors"]
                                    );
                                order_item["imprint_locations"] =
                                    item.imprint_locations
                                        ? JSON.parse(item.imprint_locations)
                                        : [];
                                order_item["imprint_locations"] = order_item[
                                    "imprint_locations"
                                ].filter(
                                    (imprint_location) =>
                                        imprint_location.is_selected
                                );
                                order_item["color_fee"] = 0;

                                // Get product images (handle both association keys)
                                const productImages =
                                    ((item.MainNewSubProduct.MainNewProducts ||
                                        item.MainNewSubProduct.MainNewProduct) &&
                                        (item.MainNewSubProduct.MainNewProducts ||
                                            item.MainNewSubProduct.MainNewProduct)
                                            .MainNewProductImages) ||
                                    [];
                                order_item["product_image"] =
                                    productImages.find(
                                        (image) =>
                                            image.color_id ==
                                            order_item.color.id
                                    );
                                if (
                                    !order_item["product_image"] &&
                                    productImages.length > 0
                                ) {
                                    order_item["product_image"] =
                                        productImages[0];
                                }
                                // Also set MainNewProductImages for compatibility
                                order_item["MainNewProductImages"] =
                                    productImages;

                                // order_item['design_image'] = JSON.parse(item.design_image)[0]['url'];
                                order_item["build_id"] = item.build_id;
                                order_item["design_area_inches"] = item.design_area_inches != null ? item.design_area_inches : null;
                                order_item["design_images"] = item.design_image
                                    ? JSON.parse(item.design_image)
                                    : [];
                                if (
                                    order_item["design_images"] &&
                                    order_item["design_images"].length > 0
                                ) {
                                    order_item["design_image"] = JSON.parse(
                                        item.design_image
                                    )[0]["url"];
                                    if (
                                        front_art_url !=
                                        order_item["design_images"][0][
                                            "design_image"
                                        ]
                                    ) {
                                        order_item["front_art_url"] =
                                            order_item["design_images"][0][
                                                "design_image"
                                            ];
                                        front_art_url =
                                            order_item["front_art_url"];
                                    }

                                    if (item.OrderBuild) {
                                        order_item["OrderBuild"] =
                                            item.OrderBuild;
                                    }
                                }
                                // console.log('check all design for images here=================================', order_item['design_images']);
                                let nameAndNumberRaw = item.name_and_number_json
                                    ? typeof item.name_and_number_json ===
                                      "string"
                                        ? JSON.parse(item.name_and_number_json)
                                        : item.name_and_number_json
                                    : [];
                                // Support both array and object { front, back, left, right }
                                let nameAndNumberArr = Array.isArray(
                                    nameAndNumberRaw
                                )
                                    ? nameAndNumberRaw
                                    : nameAndNumberRaw &&
                                      typeof nameAndNumberRaw === "object"
                                    ? ["front", "back", "left", "right"].reduce(
                                          (acc, k) =>
                                              Array.isArray(nameAndNumberRaw[k])
                                                  ? acc.concat(
                                                        nameAndNumberRaw[k]
                                                    )
                                                  : acc,
                                          []
                                      )
                                    : [];
                                order_item["name_and_number_json"] =
                                    nameAndNumberArr.filter((nn) => {
                                        if (!nn || typeof nn !== "object")
                                            return false;
                                        const hasName =
                                            nn.name != null &&
                                            String(nn.name).trim() !== "";
                                        const hasNumber =
                                            nn.number != null &&
                                            (nn.number === 0 ||
                                                nn.number === "0" ||
                                                String(nn.number).trim() !==
                                                    "");
                                        const hasSize =
                                            nn.size != null &&
                                            String(nn.size).trim() !== "";
                                        return hasName || hasNumber || hasSize;
                                    });
                                // Name/Number Color, Size, Font (for OrderDetails modal - Name Color, Number Color, etc.)
                                order_item["font_color_sizes_name"] =
                                    item.font_color_sizes_name
                                        ? typeof item.font_color_sizes_name ===
                                          "string"
                                            ? JSON.parse(
                                                  item.font_color_sizes_name
                                              )
                                            : item.font_color_sizes_name
                                        : null;
                                order_item["font_color_sizes_number"] =
                                    item.font_color_sizes_number
                                        ? typeof item.font_color_sizes_number ===
                                          "string"
                                            ? JSON.parse(
                                                  item.font_color_sizes_number
                                              )
                                            : item.font_color_sizes_number
                                        : null;
                                order_item["imprint_locations"].forEach(
                                    (location) => {
                                        order_item["color_fee"] += parseFloat(
                                            location["total_decoration_fee"]
                                        );
                                        color_fee =
                                            color_fee +
                                            parseFloat(
                                                location["total_decoration_fee"]
                                            );
                                        if (location.is_selected) {
                                            location.colors.forEach((color) => {
                                                /*  if (color.decor_upcharge) {
                                                    order_item['color_fee']+=parseFloat(color.decor_upcharge.color_cost) + parseFloat(color.cost_cost);
                                                } else {
                                                    order_item['color_fee']+=parseFloat(color.cost_cost);
                                                } */
                                                order_item["color_fee"] +=
                                                    parseFloat(
                                                        color.total_decor_upcharge
                                                    );
                                                color_fee =
                                                    color_fee +
                                                    parseFloat(
                                                        color.total_decor_upcharge
                                                    );
                                            });
                                        }
                                    }
                                );

                                order_item["total_single_location_price"] =
                                    parseFloat(item["single_location_price"]) *
                                    parseFloat(item["quantity"]);

                                order_item["total_extra_fees"] =
                                    parseFloat(item["design_fee"]) +
                                    parseFloat(order_item["color_fee"]) +
                                    parseFloat(item["single_location_price"]) *
                                        parseFloat(item["quantity"]);
                                order_item["total_price"] =
                                    parseFloat(item.total_price) +
                                    parseFloat(item.discount) +
                                    order_item["design_fee"] +
                                    order_item["non_standard_fees"] +
                                    order_item["name_number_fees"];

                                // subtotal+=parseFloat(order_item['name_number_fees']);
                                order_items.push(order_item);
                            }
                            all_setup_fee = all_setup_fee + item_setup_fee;
                            all_color_fee = all_color_fee + color_fee;
                        }
                    });

                    // PRICE BREAKUPS
                    order_items.forEach((order_item) => {
                        order_item.base_price = 0;
                        order_item.markup_price = 0;
                        order_item.markup_percentage = 0;
                        order_item.ink_price = 0;
                        order_item.single_location_price = 0;
                        order_item.sizes.forEach((size) => {
                            order_item.base_price +=
                                parseFloat(size.base_price) *
                                parseInt(size.quantity);
                            order_item.ink_price += parseFloat(size.ink_price);
                            order_item.single_location_price = parseFloat(
                                size.single_location_price
                            );
                            order_item.markup_price +=
                                parseFloat(size.markup_price) *
                                parseInt(size.quantity);
                            order_item.markup_percentage =
                                size.markup_percentage;
                        });
                        // order_item.base_price = order_item.base_price * parseInt(order_item.total_quantity)
                        order_item.ink_price =
                            parseFloat(order_item.ink_price) *
                            parseInt(order_item.total_quantity);
                        order_item.single_location_price =
                            parseFloat(order_item.single_location_price) *
                            parseInt(order_item.total_quantity);
                        // order_item.markup_price = order_item.markup_price * order_item.total_quantity;
                    });

                    order.items = order_items;
                    order.total_setup_fee = all_setup_fee;
                    order.total_color_fee = all_color_fee;
                    // Calculate subtotal from item_sub_total of all grouped order items
                    subtotal = 0;
                    let total_discount = 0;
                    order_items.forEach((order_item) => {
                        if (order_item.item_sub_total) {
                            subtotal += parseFloat(order_item.item_sub_total);
                        }
                        // Calculate total discount from all sizes in this item
                        if (
                            order_item.sizes &&
                            Array.isArray(order_item.sizes)
                        ) {
                            order_item.sizes.forEach((size) => {
                                if (size.discount) {
                                    total_discount += parseFloat(
                                        size.discount || 0
                                    );
                                }
                            });
                        } else if (order_item.total_discount) {
                            // Fallback: use total_discount if available
                            total_discount += parseFloat(
                                order_item.total_discount || 0
                            );
                        }
                    });
                    // Subtract total discount from subtotal
                    order.subtotal = subtotal - total_discount;
                    _this.order_data = order;
                    _this.processedOrderData = order;
                    // Update grand_total_price after order_data is set
                    _this.grand_total_price = _this.getGrandTotal();

                    _this.total_non_standard_colors = [
                        ...new Set(total_non_standard_colors)
                    ];
                    _this.isBusy = false;
                    if (this.paymentAlradyCompleted) {
                        _this.showCartSummaryComponent = false;
                    } else {
                        _this.showCartSummaryComponent = true;
                    }

                    // Await prepareData to ensure all async operations complete before turning off loader
                    await this.prepareData();

                    // Turn off loader only after all data fetching is complete
                    this.isLoader = false;
                    resolve(data);
                } catch (err) {
                    console.log(err);
                    _this.isBusy = false;
                    this.isLoader = false;
                    resolve({ success: false, error: err.message });
                }
            });
        },
        decycle(obj, seen = new WeakSet()) {
            if (obj !== null && typeof obj === "object") {
                if (seen.has(obj)) {
                    return "[Circular]";
                }
                seen.add(obj);

                if (Array.isArray(obj)) {
                    return obj.map((item) => this.decycle(item, seen)); // ← fix
                } else {
                    const newObj = {};
                    for (const [key, value] of Object.entries(obj)) {
                        newObj[key] = this.decycle(value, seen); // ← fix
                    }
                    return newObj;
                }
            }

            return obj;
        },

        proceedToPay() {
            return new Promise((resolve, reject) => {
                this.$validator.validateAll("paymentform").then((isValid) => {
                    if (!isValid) {
                        return;
                    }
                    if (!this.is_saved_card) {
                        this.$toast.error("Please select payment method", {
                            position: "top-right",
                            queue: true
                        });
                        return;
                    }

                    this.isLoader = true;
                    let params = {
                        order_id: this.order.id,
                        unique_order_id: this.order.unique_order_id,
                        customer_data: this.customer_data,
                        card_details: this.selected_card,
                        shipping_address: this.shipping_address_data,
                        billing_address: this.billing_address_data,
                        grand_total_price: this.grand_total_price,
                        order_data: this.removeCircularReferences(
                            this.order_data
                        ),
                        balance_after_order:
                            parseFloat(
                                this.term_payment_info.avalaible_on_account
                            ) - this.grand_total_price,
                        is_saved_card: this.is_saved_card,
                        po_number: this.po_number
                    };
                    ApiService.post("/pending-payment", params)
                        .then(({ data }) => {
                            this.isLoader = false;
                            if (!data.success) {
                                this.$toast.error(data.error, {
                                    position: "top-right",
                                    queue: true
                                });
                                return;
                            }
                            this.thankyoupayment = true;
                            this.showCartSummaryComponent = false;
                            this.$nextTick(() => {
                                window.scrollTo({ top: 0, behavior: "smooth" });
                            });
                            resolve(data);
                        })
                        .catch((err) => {
                            this.isLoader = false;
                            this.$toast.error(err, {
                                position: "top-right",
                                queue: true
                            });
                            reject(err);
                        });
                });
            });
        },

        cardNumberFormat() {
            if (this.new_card.cardnumber.replace(/\s/g, "").length < 14) {
                this.masklength = "";
            }
            if (this.new_card.cardnumber.replace(/\s/g, "").length == 14) {
                this.masklength = 14;
            }
            if (this.new_card.cardnumber.replace(/\s/g, "").length == 15) {
                this.masklength = 15;
            }
            if (this.new_card.cardnumber.replace(/\s/g, "").length == 16) {
                this.masklength = 16;
            }
            if (this.new_card.cardnumber.replace(/\s/g, "").length > 16) {
                this.masklength = 17;
            }
        },

        cardSecurityFormat() {
            var x = this.selected_card.cardsecuritycode
                .replace(/\D/g, "")
                .match(/(\d{0,3})/);
            this.selected_card.cardsecuritycode = !x[2]
                ? x[1]
                : "" + x[1] + "" + x[2] + (x[3] ? "" + x[3] : "");
        },

        changeCardYear(event, cart_data) {
            this.changedYear = event.target.value;
            if (this.changedYear == this.currentYear) {
                cart_data.cardexpiremonth = (
                    "0" +
                    (new Date().getMonth() + 1)
                ).slice(-2);
            } else {
                cart_data.cardexpiremonth = "01";
            }
        },

        selectPaymentMethod(id, expiredtime, event) {
            if (expiredtime < new Date()) {
                event.target.checked = false;
                this.is_saved_card = false;
                this.selected_card = {
                    customerProfileId: "",
                    customerPaymentProfileId: "",
                    cardtype: "",
                    cardsecuritycode: "",
                    cardnumber: "",
                    cardexpiremonth: ("0" + (new Date().getMonth() + 1)).slice(
                        -2
                    ),
                    cardexpireyear: new Date()
                        .getFullYear()
                        .toString()
                        .substr(-2)
                };
                this.$toast.error("This card has expired", {
                    position: "top-right",
                    queue: true
                });
                this.$validator.reset();
                this.$forceUpdate();
                return;
            }

            this.placeorder_add_card = false;

            this.isLoader = true;
            return new Promise((resolve, reject) => {
                ApiService.get("/getSinglePaymentMethod/" + id)
                    .then(({ data }) => {
                        if (!data.success) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }
                        this.is_saved_card = true;
                        this.is_pay_way_terms = false;
                        this.is_remaining_pay_card = false;
                        this.selected_card = {
                            customerProfileId:
                                data.payment_method.customerProfileId,
                            customerPaymentProfileId:
                                data.payment_method.customerPaymentProfileId,
                            cardtype:
                                data.payment_method.payment.creditCard.cardType,
                            cardsecuritycode: "",
                            cardnumber: data.payment_method.payment.creditCard
                                .cardNumber
                                ? data.payment_method.payment.creditCard.cardNumber
                                      .substr(-4)
                                      .replace(/\s/g, "")
                                : "",
                            cardexpiremonth:
                                data.payment_method.payment.creditCard.expirationDate
                                    .split("-")[1]
                                    .trim(),
                            cardexpireyear:
                                data.payment_method.payment.creditCard.expirationDate
                                    .split("-")[0]
                                    .split(/(.{2})/)
                                    .filter((x) => x.length == 2)[1]
                                    .trim()
                        };

                        // Ensure Pay via Credit Card radio stays checked when card is selected
                        this.$nextTick(() => {
                            const payViaCreditCardRadio =
                                document.getElementById("payviacreditcard");
                            if (payViaCreditCardRadio) {
                                payViaCreditCardRadio.checked = true;
                            }
                        });

                        this.$validator.reset();
                        this.isLoader = false;
                        resolve(data);
                    })
                    .catch((err) => {
                        console.log(err);
                        reject(err);
                    });
            });
        },

        addNewPaymentMethod() {
            let user_id = this.customer_data.user_id;
            this.$validator.validateAll("addpaymentform").then((isValid) => {
                if (isValid) {
                    this.isLoader = true;
                    this.new_card.user_id = user_id;
                    return new Promise(() => {
                        ApiService.post(
                            "/addPaymentMethodForCustomer",
                            this.new_card
                        )
                            .then(async ({ data }) => {
                                if (
                                    data.message ==
                                    "Payment method added successfully."
                                ) {
                                    document
                                        .getElementById(
                                            "popup-close-paymentform"
                                        )
                                        .click();
                                    this.$toast.success(data.message, {
                                        position: "top-right"
                                    });
                                    this.new_card.cardnumber = null;
                                    this.new_card.cardholdername = null;
                                    this.new_card.cardexpiremonth = (
                                        "0" +
                                        (new Date().getMonth() + 1)
                                    ).slice(-2);
                                    this.new_card.cardexpireyear =
                                        this.currentYear;

                                    // Refresh payment methods and update all component values
                                    await this.getAllPaymentMethods();

                                    // Force Vue to update the component to reflect changes
                                    await this.$nextTick();
                                    this.$forceUpdate();

                                    // If insufficient funds modal is open, refresh it
                                    if (
                                        $("#insufficientFundsModal").hasClass(
                                            "show"
                                        ) ||
                                        $("#insufficientFundsModal").is(
                                            ":visible"
                                        )
                                    ) {
                                        // Close and reopen modal to refresh payment methods
                                        $("#insufficientFundsModal").modal(
                                            "hide"
                                        );
                                        await this.$nextTick();
                                        setTimeout(() => {
                                            $("#insufficientFundsModal").modal(
                                                "show"
                                            );
                                            // Auto-select the newly added card (last one in the list)
                                            setTimeout(() => {
                                                if (
                                                    this.all_payment_methods &&
                                                    this.all_payment_methods
                                                        .length > 0
                                                ) {
                                                    // Get the last card (newly added)
                                                    const lastCard =
                                                        this
                                                            .all_payment_methods[
                                                            this
                                                                .all_payment_methods
                                                                .length - 1
                                                        ];
                                                    if (
                                                        lastCard &&
                                                        lastCard.customerPaymentProfileId
                                                    ) {
                                                        this.selectRemainingPaySavedCard(
                                                            lastCard.customerPaymentProfileId,
                                                            lastCard.expired_time
                                                        );
                                                    }
                                                }
                                            }, 300);
                                        }, 300);
                                    } else {
                                        // Auto-select first card if modal is not open
                                        if (
                                            this.all_payment_methods &&
                                            this.all_payment_methods.length > 0
                                        ) {
                                            this.selectPaymentMethod(
                                                this.all_payment_methods[0]
                                                    .customerPaymentProfileId,
                                                this.all_payment_methods[0]
                                                    .expired_time
                                            );
                                        }
                                    }

                                    this.$validator.reset();
                                } else {
                                    this.$toast.error(data.message, {
                                        position: "top-right"
                                    });
                                }

                                if (data.error) {
                                    this.$toast.error(data.error, {
                                        position: "top-right"
                                    });
                                }
                                this.resetCard();
                                this.isLoader = false;
                            })
                            .catch((err) => {
                                console.log(err);
                                this.isLoader = false;
                            });
                    });
                }
            });
        },

        getCustomerDetailsFromNetsuite(external_id) {
            return new Promise((resolve, reject) => {
                let params = { external_id };
                ApiService.query("get-customer-from-netsuite", { params })
                    .then(async ({ data }) => {
                        this.netsuite_customer_data = data.customer;

                        // let credit_limit = 0;
                        // let unbilledOrders = 0;
                        // if (
                        //     this.netsuite_customer_data &&
                        //     this.netsuite_customer_data.creditLimit
                        // ) {
                        //     credit_limit =
                        //         this.netsuite_customer_data.creditLimit;
                        // }

                        // await this.getUnsyncedOrdersAmount();

                        // if (
                        //     this.netsuite_customer_data &&
                        //     this.netsuite_customer_data.unbilledOrders
                        // ) {
                        //     this.netsuite_customer_data.unbilledOrders +=
                        //         parseFloat(this.unsynced_orders_amount);
                        //     unbilledOrders =
                        //         this.netsuite_customer_data.unbilledOrders;
                        // } else {
                        //     this.netsuite_customer_data.unbilledOrders =
                        //         parseFloat(this.unsynced_orders_amount);
                        //     unbilledOrders = parseFloat(
                        //         this.unsynced_orders_amount
                        //     );
                        // }

                        // let unpaidInvoices = 0;
                        // if (
                        //     this.netsuite_customer_data &&
                        //     this.netsuite_customer_data.balance
                        // ) {
                        //     unpaidInvoices = parseFloat(
                        //         this.netsuite_customer_data.balance
                        //     );
                        // }

                        // this.netsuite_customer_data.availbal =
                        //     parseFloat(credit_limit) -
                        //     parseFloat(unpaidInvoices) -
                        //     parseFloat(unbilledOrders);

                        resolve(data);
                    })
                    .catch((err) => {
                        console.log(err);
                        reject(err);
                    });
            });
        },

        getCustomerTermDetails(external_id) {
            return new Promise((resolve, reject) => {
                ApiService.query("/get-customer-term-details", {
                    params: { external_id }
                })
                    .then(async ({ data }) => {
                        if (!data.success) {
                            reject(data);
                        }

                        let termDetails = data.termDetails;
                        if (termDetails.length > 0) {
                            await this.getUnsyncedOrdersAmount();

                            let term_payment_details = termDetails[0];
                            console.log(
                                "term_payment_details",
                                term_payment_details
                            );

                            this.term_payment_info.creditlimit = parseFloat(
                                term_payment_details.creditlimit || 0
                            );
                            this.term_payment_info.overdue_balance = parseFloat(
                                term_payment_details.overdue_balance || 0
                            );
                            this.term_payment_info.unbilled_orders =
                                parseFloat(
                                    term_payment_details.unbilled_orders || 0
                                ) + parseFloat(this.unsynced_orders_amount);
                            this.term_payment_info.unpaid_invoices = parseFloat(
                                term_payment_details.unpaid_invoices || 0
                            );
                            this.term_payment_info.avalaible_on_account =
                                parseFloat(
                                    term_payment_details.avalaible_on_account ||
                                        0
                                ) - parseFloat(this.unsynced_orders_amount);
                            this.term_payment_info.unapplied_credits =
                                parseFloat(
                                    term_payment_details.unapplied_credits || 0
                                );
                        }

                        resolve(data);
                    })
                    .catch((err) => {
                        console.log(err);
                        reject(err);
                    });
            });
        },

        selectPaymentOption(option) {
            if (option == "pay_way_terms") {
                this.is_pay_way_terms = true;
                this.is_saved_card = false;
                this.selected_card = {
                    customerProfileId: "",
                    customerPaymentProfileId: "",
                    cardtype: "",
                    cardsecuritycode: "",
                    cardnumber: "",
                    cardexpiremonth: ("0" + (new Date().getMonth() + 1)).slice(
                        -2
                    ),
                    cardexpireyear: new Date()
                        .getFullYear()
                        .toString()
                        .substr(-2)
                };
                this.$validator.reset();
                this.$forceUpdate();
            } else if (option == "pay_via_credit_card") {
                this.is_pay_way_terms = false;
                this.is_remaining_pay_card = false;
                this.is_saved_card = false;
                this.$validator.reset();
                this.$forceUpdate();
            }
        },
        closePayViaTermsModal() {
            // Close insufficientFundsModal when opening add payment method modal
            /* eslint-disable */
            $("#insufficientFundsModal").modal("hide");
        },

        async onInsufficientFundsModalShown() {
            // When insufficient funds modal is shown, refresh payment methods to ensure we have the latest data
            var _this = this;

            // Refresh payment methods to ensure we have the latest data (especially after adding a new card)
            await _this.getAllPaymentMethods();

            // Use setTimeout to ensure modal is fully rendered and payment methods are loaded
            setTimeout(() => {
                // Auto-select first saved card if available
                if (
                    _this.all_payment_methods &&
                    _this.all_payment_methods.length > 0
                ) {
                    // Get first non-expired card
                    const validCards = _this.all_payment_methods.filter(
                        (method) => method.expired_time >= new Date()
                    );

                    if (validCards.length > 0) {
                        const firstCard = validCards[0];
                        // Programmatically check the radio button first
                        const radioId =
                            firstCard.customerPaymentProfileId + "id";
                        const radioElement = document.getElementById(radioId);
                        if (radioElement) {
                            radioElement.checked = true;
                        }

                        // Then select the card
                        _this.selectRemainingPaySavedCard(
                            firstCard.customerPaymentProfileId,
                            firstCard.expired_time
                        );
                    }
                }
            }, 300);
            /* eslint-enable */
        },

        selectRemainingPaySavedCard(id, expiredtime, event) {
            var _this = this;
            if (expiredtime < new Date()) {
                event.target.checked = false;
                _this.card_info2 = {
                    id: "",
                    cardtype: "",
                    cardimage: "",
                    cardnumber: "",
                    cardholdername: "",
                    cardexpiremonth: ("0" + (new Date().getMonth() + 1)).slice(
                        -2
                    ),
                    cardexpireyear: new Date()
                        .getFullYear()
                        .toString()
                        .substr(-2),
                    customerPaymentProfileId: "",
                    customerProfileId: "",
                    cardsecuritycode: ""
                };
                _this.$toast.error("This card has expired", {
                    position: "top-right",
                    queue: true
                });
                _this.$validator.reset();
                _this.$forceUpdate();
                return;
            }

            _this.isLoader = true;
            new Promise(() => {
                ApiService.get("/getSinglePaymentMethod/" + id)
                    .then(({ data }) => {
                        _this.is_remaining_pay_card = false;
                        this.is_saved_card = false;
                        _this.card_info2.customerProfileId =
                            data.payment_method.customerProfileId;
                        _this.card_info2.customerPaymentProfileId =
                            data.payment_method.customerPaymentProfileId;
                        _this.card_info2.cardtype =
                            data.payment_method.payment.creditCard.cardType;
                        _this.card_info2.cardsecuritycode = "";
                        _this.$validator.reset();
                        _this.card_info2.cardnumber = data.payment_method
                            .payment.creditCard.cardNumber
                            ? data.payment_method.payment.creditCard.cardNumber
                                  .substr(-4)
                                  .replace(/\s/g, "")
                            : "";
                        _this.card_info2.cardexpiremonth =
                            data.payment_method.payment.creditCard.expirationDate
                                .split("-")[1]
                                .trim();
                        _this.card_info2.cardexpireyear =
                            data.payment_method.payment.creditCard.expirationDate
                                .split("-")[0]
                                .split(/(.{2})/)
                                .filter((x) => x.length == 2)[1]
                                .trim();
                        _this.card_info2.cardexpiredate =
                            _this.card_info2.cardexpiremonth +
                            "/" +
                            _this.card_info2.cardexpireyear;
                        _this.isLoader = false;
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            });
        },

        resetCard() {
            this.new_card = {
                id: "",
                cardtype: "",
                cardimage: "",
                cardnumber: "",
                cardholdername: "",
                cardexpiremonth: ("0" + (new Date().getMonth() + 1)).slice(-2),
                cardexpireyear: new Date().getFullYear().toString().substr(-2)
            };
        },

        getOrdersCount() {
            return new Promise((resolve, reject) => {
                let user_id = this.customer_data.user_id;
                ApiService.query("/orders-count-without-login", {
                    params: { user_id }
                })
                    .then(({ data }) => {
                        if (!data.success) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }

                        this.total_orders = data.total_orders;
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        getUnsyncedOrdersAmount() {
            return new Promise((resolve, reject) => {
                let user_id = this.customer_data.user_id;
                // user_id = {user_id};
                ApiService.query("/unsynced-orders-amount-without-login", {
                    params: { user_id }
                })
                    .then(({ data }) => {
                        if (!data.success) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }

                        this.unsynced_orders_amount = data.total_amount;
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        payRemainingAmount() {
            // Check if card is selected - either cardnumber (last 4 digits) or customerPaymentProfileId should exist
            if (
                (!this.card_info2.cardnumber ||
                    !this.card_info2.cardnumber.trim()) &&
                (!this.card_info2.customerPaymentProfileId ||
                    !this.card_info2.customerPaymentProfileId.trim())
            ) {
                this.$toast.error("Please select card.", {
                    position: "top-right",
                    queue: true
                });
                return;
            }
            this.$validator.validateAll("insufficientForm").then((isValid) => {
                if (!isValid) {
                    return;
                }
                /* eslint-disable */
                // Just close modal and save card selection, don't navigate to review pay
                // User will click "Make Payment" button to proceed
                $("#insufficientFundsModal").modal("hide");

                // Set remaining card payment details - deep copy with all required fields
                const remainingCardDetails = {
                    cardtype: this.card_info2.cardtype || "",
                    cardimage: this.card_info2.cardimage || "",
                    cardnumber: this.card_info2.cardnumber || "",
                    cardholdername:
                        this.card_info2.cardholdername ||
                        this.customer_data.fullname ||
                        "",
                    cardexpiremonth: this.card_info2.cardexpiremonth || "",
                    cardexpireyear: this.card_info2.cardexpireyear || "",
                    cardexpiredate: this.card_info2.cardexpiredate || "",
                    customerPaymentProfileId:
                        this.card_info2.customerPaymentProfileId || "",
                    customerProfileId: this.card_info2.customerProfileId || "",
                    cardsecuritycode: this.card_info2.cardsecuritycode || ""
                };

                this.is_remaining_pay_card = true;
                this.is_pay_way_terms = true;

                // Store remaining card details for later use
                this.remaining_pay_card_details = remainingCardDetails;

                // Force update to ensure state is synced
                this.$forceUpdate();
                this.$nextTick(() => {
                    // Explicitly check the Pay via Terms radio buttons to ensure they're selected
                    const test2Radio = document.getElementById("test2");
                    const flexCheckRadio = document.getElementById("flexCheck");
                    if (test2Radio) {
                        test2Radio.checked = true;
                    }
                    if (flexCheckRadio) {
                        flexCheckRadio.checked = true;
                    }
                    // Also ensure the radio button is checked via jQuery if available
                    if (typeof $ !== "undefined") {
                        $("#test2, #flexCheck").prop("checked", true);
                    }
                });
                /* eslint-enable */
            });
        },
        payViaTerms() {
            /* eslint-disable */
            // Validate PO number if Pay via Terms is selected
            if (
                this.is_pay_way_terms &&
                this.netsuite_customer_data.terms.refName ==
                    "30P - Net 30 Days-PO"
            ) {
                if (!this.po_number || !this.po_number.trim()) {
                    this.$toast.error(
                        "PO number is required for Pay via Terms.",
                        {
                            position: "top-right",
                            queue: true
                        }
                    );
                    return;
                }
            }

            let balance_after_order =
                parseFloat(this.term_payment_info.avalaible_on_account) -
                parseFloat(this.grand_total_price);
            if (balance_after_order < 1) {
                // If remaining card payment already selected, proceed directly to payment
                if (
                    this.is_remaining_pay_card &&
                    this.remaining_pay_card_details
                ) {
                    // Proceed with payment using remaining card
                    return this.proceedWithRemainingCardPayment();
                }
                // Otherwise show modal to select card
                $("#insufficientFundsModal").modal("show");
                if (
                    this.all_payment_methods &&
                    this.all_payment_methods.length > 0
                ) {
                    this.selectRemainingPaySavedCard(
                        this.all_payment_methods[0].customerPaymentProfileId,
                        this.all_payment_methods[0].expired_time
                    );
                }
                return;
                /* eslint-enable */
            }

            return new Promise((resolve, reject) => {
                this.isLoader = true;
                let params = {
                    order_id: this.order.id,
                    unique_order_id: this.order.unique_order_id,
                    customer_data: this.customer_data,
                    shipping_address: this.shipping_address_data,
                    billing_address: this.billing_address_data,
                    additional_fees: this.additional_fees,
                    grand_total_price: this.grand_total_price,
                    balance_after_order: balance_after_order,
                    term_payment_info: this.term_payment_info,
                    is_pay_way_terms: true,
                    is_remaining_pay_card: this.is_remaining_pay_card,
                    remaining_pay_card_details: this.is_remaining_pay_card
                        ? this.remaining_pay_card_details
                        : null,
                    order_data: this.removeCircularReferences(this.order_data),
                    po_number: this.po_number
                };
                ApiService.post("/pending-payment", params)
                    .then(({ data }) => {
                        this.isLoader = false;
                        if (!data.success) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }
                        this.thankyoupayment = true;
                        this.showCartSummaryComponent = false;
                        this.$nextTick(() => {
                            window.scrollTo({ top: 0, behavior: "smooth" });
                        });
                        resolve(data);
                    })
                    .catch((err) => {
                        this.isLoader = false;
                        this.$toast.error(err, {
                            position: "top-right",
                            queue: true
                        });
                        reject(err);
                    });
            });
        },
        proceedWithRemainingCardPayment() {
            let balance_after_order =
                parseFloat(this.term_payment_info.avalaible_on_account) -
                parseFloat(this.grand_total_price);

            return new Promise((resolve, reject) => {
                this.isLoader = true;
                let params = {
                    order_id: this.order.id,
                    unique_order_id: this.order.unique_order_id,
                    customer_data: this.customer_data,
                    remaining_pay_card_details: this.remaining_pay_card_details,
                    shipping_address: this.shipping_address_data,
                    billing_address: this.billing_address_data,
                    additional_fees: this.additional_fees,
                    grand_total_price: this.grand_total_price,
                    balance_after_order: balance_after_order,
                    term_payment_info: this.term_payment_info,
                    is_pay_way_terms: true,
                    is_remaining_pay_card: true,
                    order_data: this.removeCircularReferences(this.order_data),
                    po_number: this.po_number
                };
                ApiService.post("/pending-payment", params)
                    .then(({ data }) => {
                        this.isLoader = false;
                        if (!data.success) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }
                        this.thankyoupayment = true;
                        this.showCartSummaryComponent = false;
                        this.$nextTick(() => {
                            window.scrollTo({ top: 0, behavior: "smooth" });
                        });
                        resolve(data);
                    })
                    .catch((err) => {
                        this.isLoader = false;
                        this.$toast.error(err, {
                            position: "top-right",
                            queue: true
                        });
                        reject(err);
                    });
            });
        },

        /* printPage() {
                const printContent = this.$refs.printArea.innerHTML;
                const originalContent = document.body.innerHTML;
                document.body.innerHTML = printContent;
                window.print();
                document.body.innerHTML = originalContent;
            } */
        printPage() {
            const receipt = document.querySelector(".print-reciept");
            receipt.style.display = "block";

            setTimeout(() => {
                // Force layout calculation
                receipt.offsetHeight;
                window.print();
            }, 150);
            //window.print();
        },
        showSizes(sizes) {
            if (!sizes || !Array.isArray(sizes)) return "";
            return sizes
                .filter((siz) => siz.quantity > 0)
                .map((element) => {
                    // Check both old and new structure
                    const sizeName =
                        element.MainNewSubProduct &&
                        element.MainNewSubProduct.Size
                            ? element.MainNewSubProduct.Size.size
                            : element.NewSubProduct &&
                              element.NewSubProduct.Size
                            ? element.NewSubProduct.Size.size
                            : "N/A";
                    return sizeName + ": " + element.quantity;
                })
                .join(", ");
        },
        // Parse breakdown JSON string
        parseBreakdown(breakdownString) {
            if (!breakdownString) return null;
            try {
                if (typeof breakdownString === "string") {
                    return JSON.parse(breakdownString);
                }
                return breakdownString;
            } catch (e) {
                console.error("Error parsing breakdown:", e);
                return null;
            }
        },
        // Get Packaging Breakdown
        getPackagingBreakdown() {
            if (
                !this.order_data ||
                !this.order_data.packaging_kitting_handling_breakdown
            )
                return [];
            const breakdown = this.parseBreakdown(
                this.order_data.packaging_kitting_handling_breakdown
            );
            if (!breakdown || !Array.isArray(breakdown)) return [];
            return breakdown;
        },
        // Get Packaging Total
        getPackagingTotal() {
            const breakdown = this.getPackagingBreakdown();
            if (!breakdown || breakdown.length === 0) return 0;
            let total = 0;
            breakdown.forEach((item) => {
                if (item.total && item.total !== "INCL" && item.total !== "-") {
                    total += parseFloat(item.total) || 0;
                } else if (
                    (item.amt || item.amount) &&
                    item.amt !== "INCL" &&
                    item.amt !== "-" &&
                    item.amount !== "INCL" &&
                    item.amount !== "-"
                ) {
                    total += parseFloat(item.amt || item.amount || 0);
                }
            });
            return parseFloat(total.toFixed(2));
        },
        // Get Shipping Breakdown
        getShippingBreakdown() {
            if (!this.order_data || !this.order_data.shipping_cost_breakdown)
                return [];
            const breakdown = this.parseBreakdown(
                this.order_data.shipping_cost_breakdown
            );
            if (!breakdown || !Array.isArray(breakdown)) return [];
            return breakdown;
        },
        // Get Shipping Method Charge
        getShippingMethodCharge() {
            const breakdown = this.getShippingBreakdown();
            if (!breakdown || breakdown.length === 0) return 0;
            const shippingMethodItem = breakdown.find(
                (item) =>
                    item.type === "shipping_method" ||
                    item.name === "Shipping Method Charge" ||
                    item.name === "Shipping Charge"
            );
            if (shippingMethodItem && shippingMethodItem.total) {
                return parseFloat(shippingMethodItem.total) || 0;
            }
            return 0;
        },
        // Get Shipping Total
        getShippingTotal() {
            // Always calculate from breakdown to match tooltip
            const breakdown = this.getShippingBreakdown();
            if (!breakdown || breakdown.length === 0) {
                // Fallback to order_data.ship_cost if breakdown is empty
                if (this.order_data && this.order_data.ship_cost) {
                    return parseFloat(this.order_data.ship_cost) || 0;
                }
                return 0;
            }
            let total = 0;
            breakdown.forEach((item) => {
                if (item.total && item.total !== "INCL" && item.total !== "-") {
                    total += parseFloat(item.total) || 0;
                } else if (
                    (item.amt || item.amount) &&
                    item.amt !== "INCL" &&
                    item.amt !== "-" &&
                    item.amount !== "INCL" &&
                    item.amount !== "-"
                ) {
                    total += parseFloat(item.amt || item.amount || 0);
                }
            });
            return parseFloat(total.toFixed(2));
        },
        // Get Sales Tax Breakdown
        getSalesTaxBreakdown() {
            if (!this.order_data || !this.order_data.sales_tax_breakdown)
                return [];
            const breakdown = this.parseBreakdown(
                this.order_data.sales_tax_breakdown
            );
            if (!breakdown || !Array.isArray(breakdown)) return [];
            return breakdown;
        },
        // Get Sales Tax Total
        getSalesTaxTotal() {
            // Always calculate from breakdown to match tooltip
            const breakdown = this.getSalesTaxBreakdown();
            if (!breakdown || breakdown.length === 0) {
                // Fallback to order_data.sales_tax if breakdown is empty
                if (this.order_data && this.order_data.sales_tax) {
                    return parseFloat(this.order_data.sales_tax) || 0;
                }
                return 0;
            }
            let total = 0;
            breakdown.forEach((item) => {
                if (item.total && item.total !== "INCL" && item.total !== "-") {
                    total += parseFloat(item.total) || 0;
                } else if (
                    (item.amt || item.amount) &&
                    item.amt !== "INCL" &&
                    item.amt !== "-" &&
                    item.amount !== "INCL" &&
                    item.amount !== "-"
                ) {
                    total += parseFloat(item.amt || item.amount || 0);
                }
            });
            return parseFloat(total.toFixed(2));
        },
        // Get Grand Total
        getGrandTotal() {
            // Always calculate from breakdowns for accuracy
            const subtotal = parseFloat(
                (this.order_data && this.order_data.subtotal) || 0
            );
            const packaging = this.getPackagingTotal();
            const shipping = this.getShippingTotal();
            const salesTax = this.getSalesTaxTotal();
            return parseFloat(
                (subtotal + packaging + shipping + salesTax).toFixed(2)
            );
        },
        // Helper method to check if name or number exists in name_and_number_json
        existsNameAndNumber(data, type) {
            if (!data || !Array.isArray(data)) return false;
            let is_exist = data.find(
                (nn) => nn[type] != "" && nn[type] != null
            );
            return is_exist;
        },
        // Get estimated shipping date from item
        getEstimatedShippingDate(item) {
            // First check item directly
            if (item && item.estimated_shipping_date) {
                return item.estimated_shipping_date;
            }
            // If not found, check sizes array for parent = 1
            if (
                item &&
                item.sizes &&
                Array.isArray(item.sizes) &&
                item.sizes.length > 0
            ) {
                // Find the first size with parent = 1 (main item)
                const parentSize = item.sizes.find((size) => size.parent === 1);
                if (parentSize && parentSize.estimated_shipping_date) {
                    return parentSize.estimated_shipping_date;
                }
                // Fallback: use first size if no parent = 1 found
                if (item.sizes[0] && item.sizes[0].estimated_shipping_date) {
                    return item.sizes[0].estimated_shipping_date;
                }
            }
            return null;
        },
        // Format estimated shipping date for display
        formatEstimatedShippingDate(dateString) {
            if (!dateString) return "";
            try {
                const date = new Date(dateString);
                if (isNaN(date.getTime())) return dateString;
                const mm = String(date.getMonth() + 1).padStart(2, "0");
                const dd = String(date.getDate()).padStart(2, "0");
                const yyyy = date.getFullYear();
                return `${mm}/${dd}/${yyyy}`;
            } catch (e) {
                return dateString;
            }
        },
        // Get decoration method name
        getDecorationMethodName(decorationType) {
            const decoration_type_list = {
                1: "Print",
                2: "Embroidery",
                3: "Promotional"
            };
            return decoration_type_list[decorationType] || "";
        }
    }
};
</script>

<style>
body {
    padding-top: 40px;
}

.order-tabs-wrapper .tabs-block {
    background: #fff;
    border-radius: 6px;
    border: 1px solid #eee;
}
.order-tabs-wrapper .tabs-block ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    gap: 6px;
}
.order-tabs-wrapper .tabs-block ul li {
    margin: 0;
}
.order-tabs-wrapper .tabs-block ul li a {
    display: inline-block;
    padding: 10px 14px;
    font-weight: 600;
    color: #666;
    text-decoration: none;
    border-bottom: 2px solid transparent;
}
.order-tabs-wrapper .tabs-block ul li a.active {
    color: #0079c1;
    border-bottom-color: #0079c1;
}

.payment_choice_main {
    padding: 24px 16px;
    background-color: #f4f4f4;
    border-radius: 4px;
    margin-top: 24px;
}

.shipping_payment_detail
    .white_box
    .payment_method
    .payment_choice_main
    .expiration {
    max-width: 100px;
    width: 100%;
}

.shipping_payment_detail
    .white_box
    .payment_method
    .payment_choice_main
    .securit_code {
    max-width: 100px;
    width: 100%;
}
.add_new_payment_card .payment_box {
    font-size: 14px;
    line-height: 14px;
    color: #1d6cb5;
    font-weight: 700;
}

.add_new_payment_card .cards_img {
    height: 16px;
}
.shipping_payment_detail .payment_choice_main select {
    background: url(/maincss/images/icons/down-grey.svg) no-repeat;
    background-position: right 12px bottom 15px;
}

.shipping_fl_left.card-shipping
    .payment_method
    .payment_choice_main
    .form-group
    .form-control {
    background-color: #fff !important;
    padding-left: 16px !important;
    padding-top: 0px !important;
    border: 1px solid #33333380 !important;
    height: 40px;
}
.shipping_fl_left.card-shipping .payment_method h1.payment_title {
    font-weight: 700;
    margin-bottom: 0px !important;
}
.shipping_payment .payment_choice_main .form-group label {
    top: 0px !important;
    position: relative !important;
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 20px;
    color: #121212;
    font-weight: 600;
}

.shipping_payment .payment_choice_main form.f_fl_left .alert-icon {
    top: 0px;
    right: -22px;
}
.security_alert_icon.alert-icon {
    right: -20px;
    top: -2px;
}
.pending_payment_page .payment-method-main {
    display: flex;
    gap: 24px;
    align-items: center;
    padding-left: 18px;
    margin-top: 20px;
}

.pending_payment_page .payment-method-main .coupon .form-check {
    width: 100%;
}

.payment-method-main .coupon .form-check-input {
    margin-top: 0px;
}
.cards_item_main {
    display: flex;
    align-items: center;
    gap: 16px;
}
.card_main_wrapper {
    display: flex;
    justify-content: space-between;
    max-width: 80%;
    margin-bottom: 16px;
}

.card_main_wrapper p {
    margin-bottom: 0px;
    color: #121212;
    font-size: 14px;
    line-height: 14px;
    font-weight: 400;
}
.card_main_wrapper .cards_item_main label {
    margin-bottom: 0px;
    color: #121212;
    font-size: 14px;
    line-height: 14px;
    font-weight: 400;
}
.card_main_wrapper .cards_item_main label span {
    margin-bottom: 0px;
    color: #121212;
    font-size: 14px;
    line-height: 14px;
    font-weight: 400;
    opacity: 1;
}

.cards_item_main .card_info {
    display: flex;
    align-items: center;
}

.cards_item_main .card_info .cards_img img {
    width: 26px;
    height: 16px;
    min-width: 26px;
}

.cards_item_main .card_check_item {
    position: relative;
}
.card_main_wrapper .cards_item_main label {
    margin-bottom: 0px;
    color: #121212;
    font-size: 14px;
    line-height: 14px;
    font-weight: 400;
}
.shipping_payment_detail
    .white_box
    .two_input_one_row.payment_choice_main
    .card-no {
    max-width: 200px;
    width: 100%;
}
.cards_item_main .card_check_item input {
    position: relative;
    width: 20px;
    height: 20px;
    left: 0px;
}
.shipping_fl_left.card-shipping .payment-method-main .pay-terms .pay {
    border-bottom: none !important;
    padding-bottom: 8px;
    margin-top: 0px;
}

.payment-method-main .radio-title {
    font-size: 16px;
    line-height: 16px;
    color: #121212;
    font-weight: 400;
}
.payment_cards_info {
    padding: 24px 16px 14px 16px;
    background-color: #f4f4f4;
    border-radius: 4px;
    margin-top: 24px;
}
.top_header {
    padding-bottom: 20px;
}

.top_header .header_main {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 20px;
}

.top_header .opr_logo_img {
    width: 250px;
}

.top_header .header_main .page-heading {
    font-size: 40px;
    font-weight: 700;
    line-height: 50px;
    color: #0079c1;
    border-left: 1px solid #9f9f9f;
    padding-left: 20px;
}

.top_header .header_main .left_part {
    display: flex;
    align-items: center;
}

.top_header .header_main .opr_logo_img {
    padding-right: 20px;
}

.shipping_payment_detail .cart_items {
    gap: 10px;
}

.completed-msg {
    font-size: 24px;
    font-weight: 600;
    line-height: 30px;
    color: #2b2b2b;
    margin-bottom: 0px;
    text-align: center;
}

.thank-you-msg {
    font-size: 36px;
    font-weight: 600;
    line-height: 40px;
    color: #2b2b2b;
}

.success-msg {
    background: #fff;
    padding: 24px;
    text-align: center;
}

.success-msg .thank-you-msg {
    font-size: 36px;
    font-weight: 600;
    line-height: 40px;
    color: #0079c1;
}

.shipping_payment_detail
    .cart_summary.cart-shipping-address
    .cart_summary_custome_div {
    padding: 0px;
}
.payment_choice_main .alert-icon {
    top: 0px !important;
    right: -22px !important;
}
.cart_summary .total_coast {
    padding: 10px 0 0 0;
}
.payment_choice_main .form-group label {
    top: 0px !important;
    position: relative !important;
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 20px;
    color: #121212;
    font-weight: 600;
}
.shipping_payment_detail .cart_summary.cart-shipping-address .shipping {
    padding-bottom: 10px;
}
.card_expire_date {
    margin-left: 100px;
}

.shipping_payment_detail .cart_summary.cart-shipping-address .cart_items {
    padding-top: 10px;
    padding-bottom: 10px;
}

.cart_summary .total_coast h3 {
    margin-bottom: 0px;
}

.shipping_payment_detail .cart_summary.cart-shipping-address .total_coast h5 {
    margin-bottom: 0px;
}

.success-msg p {
    color: #2b2b2b;
}

.shipping_payment_detail .cart_summary.cart-shipping-address {
    padding: 24px !important;
}

.shipping_payment_detail .payment-complete-already.white_box {
    padding: 24px !important;
}

.shipping_payment_detail
    .cart_summary.cart-shipping-address
    .cart_summary_heading_h4 {
    margin-left: 14px;
}

.pay-now-block .btn_primary {
    max-width: fit-content;
    position: absolute;
    top: 45px;
    right: 100px;
}

.insufficient-form.login-form-popup .modal-body {
    padding: 30px;
}

.insufficient-form .login-form h3 {
    font-size: 30px;
    line-height: 36px;
}

.insufficient-form.login-form-popup .form-control {
    padding: 15px 10px 0px 0px !important;
}

.insufficient-form.payViaTerms_popup .select_option_label {
    top: -22px !important;
}

.info-toggle-inside {
    position: absolute;
    left: 130px;
}

.info-toggle {
    position: relative;
}

.shipping-box {
    padding: 24px;
}

/* Breakdown Section Styles */
.order-breakdown-section {
    padding-top: 20px;
    margin-top: 20px;
}

.breakdown-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    font-size: 16px;
}

.breakdown-label {
    color: #333;
    font-weight: normal;
}

.breakdown-value {
    color: #333;
    font-weight: normal;
    text-align: right;
}

.breakdown-item .cost-label {
    display: inline-flex;
    align-items: center;
    color: #333;
    font-weight: normal;
}

@media (max-width: 1200px) {
    .shipping_payment_detail .payment-complete-already.white_box {
        padding: 24px !important;
    }

    .shipping_payment_detail .cart_summary.h-100.white_box.py_52.px_52 {
        padding: 24px !important;
    }

    .top_header .header_main .page-heading {
        font-size: 30px;
        line-height: 30px;
    }
}

@media (max-width: 991px) {
    .top_header .header_main {
        flex-direction: column;
    }

    .top_header .header_main .left_part {
        flex-direction: column;
        gap: 20px;
        align-items: flex-start;
    }

    .top_header .header_main .page-heading {
        border-left: none;
        padding-left: 0px;
        font-size: 30px;
        line-height: 30px;
    }

    .pay-now-block .btn_primary {
        max-width: fit-content;
        right: 20px;
        padding: 10px 16px;
    }

    .top_header .opr_logo_img {
        width: 200px;
    }
}

@media print {
    /* Hide everything first */
    @page {
        margin: 20px;
    }

    /* body * {
    visibility: hidden;
    border: none !important;
  } */
    .standard_colors li {
        margin-right: 4px;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }

    /* Show only the print receipt */
    .print-reciept,
    .print-reciept * {
        visibility: visible;
    }

    /* Position the receipt at the top-left corner in print */
    .print-reciept {
        position: absolute;
        left: 0;
        top: 0;
    }

    /* Hide the print button */
    .btn {
        display: none !important;
    }
}
</style>
